
document.querySelectorAll('input[name="adequate-sleep"]').forEach((el) => {
    el.addEventListener('change', () => {
        document.querySelector('.sleep-duration').style.display = el.value === 'no' ? 'block' : 'none';
    });
});

document.querySelectorAll('input[name="alcohol-consumption"]').forEach((el) => {
    el.addEventListener('change', () => {
        const alcoholTier = document.querySelector('.alcohol-tier');
        const wiseChoice = document.querySelector('.wise-choice.alcohol');
        
        if (el.value === 'yes') {
            alcoholTier.style.display = 'block';
            if (wiseChoice) wiseChoice.style.display = 'none';
        } else {
            alcoholTier.style.display = 'none';
            if (wiseChoice) wiseChoice.style.display = 'block';
        }
    });
});

document.querySelectorAll('input[name="smoking-habit"]').forEach((el) => {
    el.addEventListener('change', () => {
        const smokingTier = document.querySelector('.smoking-tier');
        const wiseChoice = document.querySelector('.wise-choice.smoking');
        
        if (el.value === 'yes') {
            smokingTier.style.display = 'block';
            if (wiseChoice) wiseChoice.style.display = 'none';
        } else {
            smokingTier.style.display = 'none';
            if (wiseChoice) wiseChoice.style.display = 'block';
        }
    });
});
// Application state
let currentStep = 1;
let totalSteps = 10;
let skipExercise = false;
let userData = {};

// Calculation constants
const EXERCISE_MET = {
    light: 2.31,
    moderate: 4.41,
    high: 7.25,
    very_high: 10.4,
    max_effort: 15.2,
};

const ACTIVITY_MULTIPLIERS = {
    male: {
        sedentary: 0.1,
        lightly_active: 0.23,
        moderately_active: 0.35,
        very_active: 0.48,
        extremely_active: 0.6,
    },
    female: {
        sedentary: 0.1,
        lightly_active: 0.23,
        moderately_active: 0.35,
        very_active: 0.48,
        extremely_active: 0.6,
    },
};

const FITNESS_GOALS = {
    lose_fat_maintain_muscle: { multiplier: 0.85, protein: 2.2, fat: 0.9, name: 'Lose Fat & Maintain Muscle' },
    lose_fat_gain_muscle: { multiplier: 0.95, protein: 2.35, fat: 0.9, name: 'Body Recomposition' },
    maintain: { multiplier: 1.0, protein: 1.8, fat: 0.9, name: 'Maintain Current State' },
    gain_muscle: { multiplier: 1.1, protein: 2.2, fat: 0.9, name: 'Gain Muscle Mass' },
    get_faster: { multiplier: 1.05, protein: 1.8, fat: 0.9, name: 'Improve Endurance' },
    increase_strength: { multiplier: 1.1, protein: 2.2, fat: 0.9, name: 'Increase Strength' },
    recovering_injury: { multiplier: 1.0, protein: 2.15, fat: 1.1, name: 'Recovery from Injury' },
};
/**
 * @constant {object} SLEEP_IMPACT
 * @description Metabolic impact multipliers based on sleep duration.
 */
const SLEEP_IMPACT = {
    yes: { rmr: 1.0, neat: 1.0, eat: 1.0, tef: 1.0, bmi: 1.0, bodyFat: 1.0 }, // Adequate sleep
    no: {
        '<5': { rmr: 0.92, neat: 0.80, eat: 0.80, tef: 0.95, bmi: 1.08, bodyFat: 1.20 }, // < 5 hours
        '5-6': { rmr: 0.95, neat: 0.90, eat: 0.90, tef: 0.97, bmi: 1.04, bodyFat: 1.10 }, // 5-6 hours
        '6-7': { rmr: 0.98, neat: 0.95, eat: 0.95, tef: 1.0, bmi: 1.02, bodyFat: 1.05 }, // 6-7 hours
        '7-8': { rmr: 1.0, neat: 1.0, eat: 1.0, tef: 1.0, bmi: 1.0, bodyFat: 1.0 },   // 7-8 hours (baseline)
        '>8': { rmr: 1.0, neat: 1.0, eat: 1.0, tef: 1.0, bmi: 1.0, bodyFat: 1.0 },    // > 8 hours (no negative impact)
    },
};

/**
 * @constant {object} ALCOHOL_IMPACT
 * @description Metabolic and Body Fat impact multipliers based on alcohol consumption tiers.
 */
const ALCOHOL_IMPACT = {
    none: { rmr: 1.0, neat: 1.0, eat: 1.0, tef: 1.0, bmi: 1.0, bodyFat: 1.0 },
    casual: { rmr: 1.0, neat: 1.0, eat: 1.0, tef: 1.08, bmi: 1.0, bodyFat: 1.02 }, // Corresponds to 1-2 drinks/week
    regular: { rmr: 0.98, neat: 0.92, eat: 0.92, tef: 1.13, bmi: 1.02, bodyFat: 1.08 }, // Corresponds to 3-7 drinks/week
    heavy: { rmr: 0.96, neat: 0.85, eat: 0.85, tef: 1.18, bmi: 1.04, bodyFat: 1.13 }, // Corresponds to >7 drinks/week
};

/**
 * @constant {object} SMOKING_IMPACT
 * @description Metabolic and Body Fat impact multipliers based on smoking tiers.
 */
const SMOKING_IMPACT = {
    no: { rmr: 1.0, neat: 1.0, eat: 1.0, tef: 1.0, bmi: 1.0, bodyFat: 1.0 },
    yes: {
        casual: { rmr: 1.02, neat: 0.97, eat: 0.97, tef: 1.0, bmi: 0.98, bodyFat: 1.02 }, // Corresponds to 1-2/day
        regular: { rmr: 1.05, neat: 0.92, eat: 0.92, tef: 1.0, bmi: 0.97, bodyFat: 1.08 }, // Corresponds to 5-10/day
        heavy: { rmr: 1.09, neat: 0.85, eat: 0.85, tef: 1.0, bmi: 0.95, bodyFat: 1.13 }, // Corresponds to >10/day
    },
};
// NEW: Complete data collection function
function collectAllUserData() {
    // Collect exercise data
    const exerciseData = {};
    Object.keys(EXERCISE_MET).forEach((intensity) => {
        const minutesId = intensity.replace('_', '-') + '-minutes';
        exerciseData[intensity] = getValue(minutesId) || 0;
    });

    return {
        // Personal Information
        personalInfo: {
            name: document.getElementById('user-name')?.value || '',
            email: document.getElementById('user-email')?.value || '',
            age: getValue('age'),
            gender: getRadioValue('biological-gender'),
        },

        // Physical Measurements
        measurements: {
            weight: convertWeightToKg(),
            height: convertHeightToCm(),
            heightDisplay: getHeightDisplay(),
            heightUnit: getRadioValue('height-unit'),
            bodyFat: getValue('custom-body-fat'),
            bmi: userData.bmi || 0,
            bmiCategory: userData.bmiCategory || '',
            lbm: userData.lbm || 0,
            fatMass: userData.fatMass || 0,
            waist: convertWaistToCm(),
            hip: convertHipToCm(),
        },

      // Activity & Exercise
      
    activity: {
        level: getRadioValue('activity-level'),
            dontExercise: document.getElementById('dont-exercise')?.checked || false,
                exerciseMinutes: exerciseData,
                    sleepHours: getRadioValue('sleep-hours'),
                        adequateSleep: getRadioValue('adequate-sleep'),
                            sleepDuration: getRadioValue('sleep-duration'),
                                alcoholConsumption: getRadioValue('alcohol-consumption'),
                                    alcoholTier: getRadioValue('alcohol-tier'),
                                        smokingStatus: getRadioValue('smoking-habit'),
                                            smokingTier: getRadioValue('smoking-tier'),
        },
    // Metabolic Data
    metabolism: {
        rmr: userData.rmr || 0,
            neat: userData.neat || 0,
                eat: userData.eat || 0,
                    tef: userData.tef || 0,
                        tdee: userData.tdee || 0,
                        bmr : userData.bmr  || 0,
      },

    // Nutrition
    nutrition: {
        targetCalories: userData.targetCalories || 0,
            protein: userData.protein || 0,
                carbs: userData.carbs || 0,
                    fats: userData.fats || 0,
      },

    // Goals
    goals: userData.selectedGoals || [],

        // Metadata
        metadata: {
        skipExercise: skipExercise,
            currentStep: currentStep,
                timestamp: new Date().toISOString(),
                    calculatorVersion: '1.0',
      },
};
  }

// NEW: Global access function
function getUserData() {
    return collectAllUserData();
}

// Make it globally accessible
window.getUserCalculatorData = getUserData;


function getValue(id) {
    const element = document.getElementById(id);
    return element ? parseFloat(element.value) || 0 : 0;
}

function setValue(id, value, decimals = 0) {
    const element = document.getElementById(id);
    if (element) {
        element.value = parseFloat(value).toFixed(decimals);
    }
}

function setDisplay(id, value, decimals = 0) {
    const element = document.getElementById(id);
    if (element) {
        element.textContent = parseFloat(value).toFixed(decimals);
    }
}

function getRadioValue(name) {
    const radio = document.querySelector(`input[name="${name}"]:checked`);
    return radio ? radio.value : '';
}

function getSelectedGoals() {
    const checkboxes = document.querySelectorAll('input[name="fitness-goals"]:checked');
    return Array.from(checkboxes).map((cb) => cb.value);
}

// Height conversion functions
// Toggle between Imperial and Metric systems
function initUnitSystemToggle() {
    const imperialRadio = document.getElementById('system-imperial');
    const metricRadio = document.getElementById('system-metric');

    imperialRadio.addEventListener('change', function () {
        if (this.checked) {
            showImperialUnits();
        }
    });

    metricRadio.addEventListener('change', function () {
        if (this.checked) {
            showMetricUnits();
        }
    });
}

function showImperialUnits() {
    // Show imperial, hide metric for weight
    document.getElementById('weight-imperial-group').style.display = 'block';
    document.getElementById('weight-metric-group').style.display = 'none';

    // Show imperial, hide metric for height
    document.getElementById('height-imperial-group').style.display = 'block';
    document.getElementById('height-metric-group').style.display = 'none';

    // Show imperial, hide metric for waist
    document.getElementById('waist-inches-group').style.display = 'block';
    document.getElementById('waist-cm-group').style.display = 'none';

    // Show imperial, hide metric for hip
    document.getElementById('hip-inches-group').style.display = 'block';
    document.getElementById('hip-cm-group').style.display = 'none';
}

function showMetricUnits() {
    // Show metric, hide imperial for weight
    document.getElementById('weight-imperial-group').style.display = 'none';
    document.getElementById('weight-metric-group').style.display = 'block';

    // Show metric, hide imperial for height
    document.getElementById('height-imperial-group').style.display = 'none';
    document.getElementById('height-metric-group').style.display = 'block';

    // Show metric, hide imperial for waist
    document.getElementById('waist-inches-group').style.display = 'none';
    document.getElementById('waist-cm-group').style.display = 'block';

    // Show metric, hide imperial for hip
    document.getElementById('hip-inches-group').style.display = 'none';
    document.getElementById('hip-cm-group').style.display = 'block';
}

// Convert weight to kg
function convertWeightToKg() {
    const unit = getRadioValue('unit-system');

    if (unit === 'imperial') {
        const weightLbs = getValue('weight-lbs');
        return parseFloat((weightLbs * 0.453592).toFixed(2)); // Convert lbs to kg with 2 decimals
    }

    return parseFloat(getValue('weight').toFixed(2)); // Already in kg, ensure 2 decimals
}

// Convert height to cm
function convertHeightToCm() {
    const unit = getRadioValue('unit-system');

    if (unit === 'imperial') {
        const feet = getValue('height-feet');
        const inches = getValue('height-inches');
        return (feet * 12 + inches) * 2.54; // Convert to cm
    }

    return getValue('height'); // Already in cm
}

// Convert waist to cm
function convertWaistToCm() {
    const unit = getRadioValue('unit-system');

    if (unit === 'imperial') {
        const waistInches = getValue('waist-inches');
        return waistInches * 2.54; // Convert inches to cm
    }

    return getValue('waist-cm'); // Already in cm
}

// Convert hip to cm
function convertHipToCm() {
    const unit = getRadioValue('unit-system');

    if (unit === 'imperial') {
        const hipInches = getValue('hip-inches');
        return hipInches * 2.54; // Convert inches to cm
    }

    return getValue('hip-cm'); // Already in cm
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
    initUnitSystemToggle();
});

// Usage in your existing code:


function getHeightDisplay() {
    const unit = getRadioValue('height-unit');
    if (unit === 'feet-inches') {
        const feet = getValue('height-feet');
        const inches = getValue('height-inches');
        return `${feet}'${inches}"`;
    } else if (unit === 'inches') {
        return `${getValue('height-inches-only')}"`;
    }
    return `${getValue('height')} cm`;
}

// Email validation
function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Real-time validation
function validateInput(input) {
    const value = parseFloat(input.value);
    const min = parseFloat(input.getAttribute('min')) || -Infinity;
    const max = parseFloat(input.getAttribute('max')) || Infinity;
    const required = input.hasAttribute('required');
    let formGroup = input.closest('.form-group');
    if (!formGroup) return true;

    let isValid = true;

    if (input.type === 'email') {
        isValid = validateEmail(input.value);
    } else if (required && (!input.value.trim() || (input.type === 'number' && isNaN(value)))) {
        isValid = false;
    } else if (input.type === 'number' && !isNaN(value) && (value < min || value > max)) {
        isValid = false;
    }
    const errorElement = formGroup.querySelector('.error-message');
    if (isValid) {
        formGroup.classList.remove('error');
        formGroup.classList.add('valid');
        if (errorElement) errorElement.style.display = 'none';
    } else {
        formGroup.classList.remove('valid');
        formGroup.classList.add('error');
        if (errorElement) errorElement.style.display = 'block';
    }

    return isValid;
}

// Progress bar update
function updateProgress() {
    const actualTotalSteps = skipExercise ? 10 : 10;
    if (currentStep > 1) {
        document.querySelector('.calc-outer-wrapper')?.classList.add('sidebaractive');
    } else {
        document.querySelector('.calc-outer-wrapper')?.classList.remove('sidebaractive');
    }


    let adjustedCurrentStep = currentStep;
    if (skipExercise && currentStep >= 10) {
        adjustedCurrentStep = currentStep - 2;
    }
    const percentage = (adjustedCurrentStep / actualTotalSteps) * 100;
    document.getElementById('progress-fill').style.width = percentage + '%';
    document.getElementById('progress-text').textContent = `Step ${adjustedCurrentStep} of ${actualTotalSteps}`;
    document.getElementById('progress-percentage').textContent = Math.round(percentage) + '%';
}

function getHealthRiskAssessment(bmiValue, waistValue, whrValue, bodyFatElement, gender) {
    // console.log('Input values:', { bmiValue, waistValue, whrValue, bodyFatElement, gender });

    if (!bodyFatElement) {
        console.log('Body fat percentage not provided');
        return null;
    }

    const match = WHRDATA.find((item) => {
        const bmiMatch = checkBMIRange(bmiValue, item['BMI Range']);
        const waistMatch = checkWaistRange(waistValue, item['Waist Range'], gender);
        const whrMatch = checkWHRRange(whrValue, item['WHR Range'], gender);
        const bodyFatMatch = checkBodyFatRange(bodyFatElement, item['Body Fat % Range'], gender);


        return bmiMatch && waistMatch && whrMatch && bodyFatMatch;
    });



    if (match) {
        return {
            bmi_category: match['BMI Category'],
            waist_category: match['Waist Category'],
            whr_category: match['WHR Category'],
            body_fat_category: match['Body Fat Category'],
            suggested_message: match['comment'].replace(/\\n/g, '\n'),
        };
    }

    return null;
}

function checkBMIRange(value, bmiRange) {
    if (!bmiRange || bmiRange === 'NA') return true;

    if (bmiRange.includes('–') || bmiRange.includes('-')) {
        const separator = bmiRange.includes('–') ? '–' : '-';
        const [min, max] = bmiRange.split(separator).map((x) => parseFloat(x.trim()));
        return value >= min && value <= max;
    } else if (bmiRange.includes('≥')) {
        const threshold = parseFloat(bmiRange.replace('≥', '').trim());
        return value >= threshold;
    } else if (bmiRange.startsWith('<')) {
        const threshold = parseFloat(bmiRange.replace('<', '').trim());
        return value < threshold;
    }
    return false;
}

function checkWaistRange(value, waistRange, gender) {
    if (!waistRange || waistRange === 'NA') return true;

    const isMale = gender.toLowerCase() === 'male' || gender.toLowerCase() === 'men';

    let genderRange;
    if (waistRange.includes('/')) {
        const ranges = waistRange.split('/');
        genderRange = isMale ? ranges[0].trim() : ranges[1].trim();
    } else {
        genderRange = waistRange.trim();
    }

    genderRange = genderRange.replace(/cm|\(M\)|\(F\)/g, '').trim();



    if (genderRange.startsWith('<')) {
        const threshold = parseFloat(genderRange.replace('<', '').trim());
        return value < threshold;
    } else if (genderRange.startsWith('>')) {
        const threshold = parseFloat(genderRange.replace('>', '').trim());
        return value > threshold;
    } else if (genderRange.includes('–')) {
        const [min, max] = genderRange.split('–').map((x) => parseFloat(x.trim()));
        return value >= min && value <= max;
    }
    return false;
}

function checkWHRRange(value, whrRange, gender) {
    if (!whrRange || whrRange === 'NA') return true;

    const isMale = gender.toLowerCase() === 'male' || gender.toLowerCase() === 'men';

    let genderRange;
    if (whrRange.includes('/')) {
        const ranges = whrRange.split('/');
        genderRange = isMale ? ranges[0].trim() : ranges[1].trim();
    } else {
        genderRange = whrRange.trim();
    }



    if (genderRange.startsWith('<')) {
        const threshold = parseFloat(genderRange.replace('<', '').trim());
        return value < threshold;
    } else if (genderRange.startsWith('>')) {
        const threshold = parseFloat(genderRange.replace('>', '').trim());
        return value > threshold;
    } else if (genderRange.includes('≤')) {
        const threshold = parseFloat(genderRange.replace('≤', '').trim());
        return value <= threshold;
    } else if (genderRange.includes('≥')) {
        const threshold = parseFloat(genderRange.replace('≥', '').trim());
        return value >= threshold;
    } else if (genderRange.includes('–')) {
        const [min, max] = genderRange.split('–').map((x) => parseFloat(x.trim()));
        return value >= min && value <= max;
    }
    return false;
}

function checkBodyFatRange(value, bodyFatRange, gender) {
    if (!bodyFatRange || bodyFatRange === 'NA') return true;

    const isMale = gender.toLowerCase() === 'male' || gender.toLowerCase() === 'men';

    let genderRange;
    if (bodyFatRange.includes('/')) {
        const ranges = bodyFatRange.split('/');
        genderRange = isMale ? ranges[0].trim() : ranges[1].trim();
    } else {
        genderRange = bodyFatRange.trim();
    }

    genderRange = genderRange.replace(/%/g, '').trim();



    if (genderRange.includes('≥')) {
        const threshold = parseFloat(genderRange.replace('≥', '').trim());
        return value >= threshold;
    } else if (genderRange.includes('–')) {
        const [min, max] = genderRange.split('–').map((x) => parseFloat(x.trim()));
        return value >= min && value <= max;
    } else if (genderRange.includes('<')) {
        const threshold = parseFloat(genderRange.replace('<', '').trim());
        return value < threshold;
    }
    return false;
}

// Complete Speedometer Animation System - ONE FUNCTION TO CALL
function animateHealthSpeedometers() {
    // Configuration
    const speedometerConfig = {
        bmi: {
            min: 10,
            max: 45,
            riskThresholds: {
                high: [0, 16], // Severe Underweight
                moderate: [16, 18.5], // Underweight
                low: [18.5, 24.9], // Normal
                moderate2: [25.0, 29.9], // Overweight
                high2: [30.0, 34.9], // Obese Class I
                veryHigh: [35.0, 39.9], // Obese Class II
                extreme: [40, 100], // Obese Class III
            },
        },
        waist: {
            male: { min: 70, max: 120, riskThresholds: { low: [0, 94], moderate: [94, 101], high: [101, 200] } },
            female: { min: 60, max: 110, riskThresholds: { low: [0, 80], moderate: [80, 87], high: [87, 200] } },
        },
        whr: {
            male: { min: 0.6, max: 1.2, riskThresholds: { low: [0, 0.9], moderate: [0.9, 0.95], high: [0.95, 2] } },
            female: { min: 0.6, max: 1.2, riskThresholds: { low: [0, 0.8], moderate: [0.8, 0.85], high: [0.85, 2] } },
        },
        whrRisk: {
            min: 1,
            max: 4,
            categories: { 'Low Risk': 1, 'Moderate Risk': 2, 'High Risk': 3, 'Very High Risk': 4 },
        },
        bodyFat: {
            male: {
                min: 0,
                max: 50,
                riskThresholds: {
                    low: [3, 5], // Essential Fat
                    good: [6, 13], // Athletic
                    normal: [14, 17], // Good
                    acceptable: [18, 24], // Acceptable
                    moderate: [25, 31], // Overweight
                    high: [32, 100], // Obese
                },
            },
            female: {
                min: 0,
                max: 50,
                riskThresholds: {
                    low: [10, 13], // Essential Fat
                    good: [14, 20], // Athletic
                    normal: [21, 24], // Good
                    acceptable: [25, 31], // Acceptable
                    moderate: [32, 39], // Overweight
                    high: [40, 100], // Obese
                },
            },
        },
        leanMass: { min: 20, max: 100 },
        fatMass: { min: 5, max: 50 },
    };

    // Helper functions
    const getBMIRiskLevel = (value) => {
        if (value < 16) return 'high'; // Severe Underweight
        if (value < 18.5) return 'moderate'; // Underweight
        if (value <= 24.9) return 'low'; // Normal
        if (value <= 29.9) return 'moderate'; // Overweight
        if (value <= 34.9) return 'high'; // Obese Class I
        if (value <= 39.9) return 'high'; // Obese Class II
        return 'high'; // Obese Class III
    };

    const getBodyFatRiskLevel = (value, gender) => {
        if (!gender) return 'normal';
        const config = speedometerConfig.bodyFat[gender.toLowerCase()];
        if (!config) return 'normal';

        const thresholds = config.riskThresholds;
        if (value >= thresholds.low[0] && value <= thresholds.low[1]) return 'low';
        if (value >= thresholds.good[0] && value <= thresholds.good[1]) return 'low';
        if (value >= thresholds.normal[0] && value <= thresholds.normal[1]) return 'low';
        if (value >= thresholds.acceptable[0] && value <= thresholds.acceptable[1]) return 'moderate';
        if (value >= thresholds.moderate[0] && value <= thresholds.moderate[1]) return 'moderate';
        if (value >= thresholds.high[0]) return 'high';
        return 'low'; // Below essential fat range
    };

    const getRiskLevel = (value, thresholds) => {
        if (!thresholds) return 'normal';
        if (thresholds.high && value >= thresholds.high[0]) return 'high';
        if (thresholds.moderate && value >= thresholds.moderate[0] && value < thresholds.high[0]) return 'moderate';
        if (thresholds.low && value >= thresholds.low[0] && value < thresholds.moderate[0]) return 'low';
        return 'low';
    };

    const getRiskColor = (riskLevel) => {
        const colors = {
            low: '#10b981', // Green - Good
            normal: '#10b981', // Green - Good
            moderate: '#f59e0b', // Yellow - Moderate Risk
            high: '#ef4444', // Red - High Risk
            'very-high': '#ef4444', // Red - High Risk
        };
        return colors[riskLevel] || colors.normal;
    };
    const animateSpeedometer = (arcId, needleId, value, min, max, riskLevel = 'normal', delay = 0) => {
        const needle = document.getElementById(needleId);

        if (!needle) {
            console.warn(`Speedometer element not found: ${needleId}`);
            return;
        }

        const percentage = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
        const needleRotation = -90 + (percentage / 100) * 180;

        setTimeout(() => {
            needle.setAttribute('transform', `rotate(${needleRotation} 100 90)`);

            const card = needle.closest('.result-card');
            if (card) {
                card.className = card.className.replace(/risk-\w+/g, '');
                card.classList.add(`risk-${riskLevel}`);
            }
        }, delay);
    };
    

const animateWHRNeedle = (whrValue, whrMin, whrMax, riskLevel = 'normal', delay = 0) => {
    // 1. Get the SVG group that holds the needle polygon and center circle
    const needleGroup = document.getElementById('whr-needle');
    const displayElement = document.getElementById('whr-display');

    if (!needleGroup) {
        console.warn('WHR Speedometer needle group (#whr-needle) not found.');
        return;
    }

    // --- Data Calculation ---
    
    // Safety check: Clamp value to prevent over-rotation
    const clampedValue = Math.min(Math.max(whrValue, whrMin), whrMax);

    // Calculate the normalized ratio (0 to 1)
    const ratio = (clampedValue - whrMin) / (whrMax - whrMin);

    // Calculate the rotation angle (total arc is 180 degrees)
    // Start angle: -90 degrees (9 o'clock / Green start)
    // End angle: +90 degrees (3 o'clock / Red end)
    const rotationAngle = -90 + (ratio * 180);

    // --- Animation Execution ---

    setTimeout(() => {
        // Force transition properties for smooth movement
        needleGroup.style.transition = 'transform 700ms cubic-bezier(0.4, 0.0, 0.2, 1)';
        
        // Apply the rotation transform
        // Pivot is (100, 90) as defined in your SVG's <g> element
        needleGroup.setAttribute('transform', `rotate(${rotationAngle} 100 90)`);
        
        // --- UI Updates ---
        
        // Update the display text
        if (displayElement) {
            displayElement.innerText = whrValue.toFixed(2);
        }

        // Update the card risk class
        const card = needleGroup.closest('.result-card');
        if (card) {
            // Robustly remove old risk classes before adding new one
            card.classList.remove('risk-low', 'risk-moderate', 'risk-high', 'risk-normal');
            card.classList.add(`risk-${riskLevel}`);
        }
    }, delay);
};


    /* const animateSpeedometer = (arcId, needleId, value, min, max, riskLevel = 'normal', delay = 0) => {
       const arc = document.getElementById(arcId);
       const needle = document.getElementById(needleId);
 
       if (!arc || !needle) {
         console.warn(`Speedometer elements not found: ${arcId}, ${needleId}`);
         return;
       }
 
       //const percentage = Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
       const percentage = Math.max(5, Math.min(100, ((value - min) / (max - min)) * 100)); // Changed this line
       const arcFill = 220 - (percentage / 100) * 220;
       const needleRotation = -90 + (percentage / 100) * 180;
       const color = getRiskColor(riskLevel);
 
       setTimeout(() => {
         arc.style.strokeDashoffset = arcFill;
         arc.style.stroke = color;
         needle.style.transform = `rotate(${needleRotation}deg)`;
 
         const card = arc.closest('.result-card');
         if (card) {
           card.className = card.className.replace(/risk-\w+/g, '');
           card.classList.add(`risk-${riskLevel}`);
         }
       }, delay);
     };*/

    // Main animation logic
    const gender = getRadioValue('biological-gender');

    if (!userData.bmi) {
        console.warn('No data available for speedometer animation');
        return;
    }

    // BMI Speedometer - Using custom BMI risk assessment
    const bmiRisk = getBMIRiskLevel(userData.bmi);
    animateSpeedometer(
        'bmi-arc',
        'bmi-needle',
        userData.bmi,
        speedometerConfig.bmi.min,
        speedometerConfig.bmi.max,
        bmiRisk,
        200
    );

    // Waist Speedometer
    if (userData.waist && gender) {
        const waistConfig = speedometerConfig.waist[gender.toLowerCase()];
        if (waistConfig) {
            const waistRisk = getRiskLevel(userData.waist, waistConfig.riskThresholds);
            animateSpeedometer(
                'waist-arc',
                'waist-needle',
                userData.waist,
                waistConfig.min,
                waistConfig.max,
                waistRisk,
                400
            );
        }
    }

    // WHR Speedometer
 if (userData.whr && gender) {
    const whrConfig = speedometerConfig.whr[gender.toLowerCase()];
    if (whrConfig) {
        const whrRisk = getRiskLevel(userData.whr, whrConfig.riskThresholds);

        // USE THE NEW FUNCTION:
        animateWHRNeedle(
            userData.whr, 
            whrConfig.min, 
            whrConfig.max, 
            whrRisk, 
            600 // Delay
        );
    }
}

    // WHR Risk Level Speedometer
    if (userData.whrCategory) {
        const riskValue = speedometerConfig.whrRisk.categories[userData.whrCategory] || 1;
        let riskLevel = 'low';
        if (userData.whrCategory.includes('Moderate')) riskLevel = 'moderate';
        else if (userData.whrCategory.includes('High')) riskLevel = 'high';

        animateSpeedometer(
            'whr-risk-arc',
            'whr-risk-needle',
            riskValue,
            speedometerConfig.whrRisk.min,
            speedometerConfig.whrRisk.max,
            riskLevel,
            800
        );
    }

    // Body Fat Speedometer - Using gender-specific ranges
    if (userData.bodyFat && gender) {
        const bodyFatRisk = getBodyFatRiskLevel(userData.bodyFat, gender);
       
        document.getElementById('body-fat-display').textContent = bodyFatRisk;
        const bodyFatConfig = speedometerConfig.bodyFat[gender.toLowerCase()];
        if (bodyFatConfig) {
            animateSpeedometer(
                'bodyfat-arc',
                'bodyfat-needle',
                userData.bodyFat,
                bodyFatConfig.min,
                bodyFatConfig.max,
                bodyFatRisk,
                1000
            );
        }
    }

    // Lean Mass Speedometer
    if (userData.leanMass) {
        let leanMassRisk = 'moderate';
        if (userData.leanMass >= 60) leanMassRisk = 'low';
        else if (userData.leanMass >= 45) leanMassRisk = 'low';
        else leanMassRisk = 'moderate';

        animateSpeedometer(
            'lean-mass-arc',
            'lean-mass-needle',
            userData.leanMass,
            speedometerConfig.leanMass.min,
            speedometerConfig.leanMass.max,
            leanMassRisk,
            1200
        );
    }

    // Fat Mass Speedometer
    if (userData.fatMass) {
        let fatMassRisk = 'low';
        if (userData.fatMass <= 15) fatMassRisk = 'low';
        else if (userData.fatMass <= 25) fatMassRisk = 'low';
        else if (userData.fatMass <= 35) fatMassRisk = 'moderate';
        else fatMassRisk = 'high';

        animateSpeedometer(
            'fat-mass-arc',
            'fat-mass-needle',
            userData.fatMass,
            speedometerConfig.fatMass.min,
            speedometerConfig.fatMass.max,
            fatMassRisk,
            1400
        );
    }
}

function calculateComprehensiveHealthRisk() {
    const bmi = userData.bmi || calculateBMI();
    const heightUnit = getRadioValue('height-unit');
    const gender = getRadioValue('biological-gender');

    let waist, hip;
    const measurementUnit = getRadioValue('measurement-unit');
    // Get values based on current unit and convert to cm if needed
    if (measurementUnit === 'cm') {
        waist = getValue('waist-cm');
        hip = getValue('hip-cm');
    } else {
        // inches or feet-inches
        const waistInches = getValue('waist-inches');
        const hipInches = getValue('hip-inches');

        // Convert inches to cm (1 inch = 2.54 cm)
        waist = waistInches * 2.54;
        hip = hipInches * 2.54;
    }
    waist = convertWaistToCm();
    hip = convertHipToCm();

    const waistValue = waist;
    const hipValue = hip;

    // Get body fat percentage
    const bodyFatElement = document.getElementById('custom-body-fat').value;
    
    //const bodyFatValue = bodyFatElement ? parseFloat(bodyFatElement.value) : null;

    if (!bmi || !waist || !hip || !gender || !bodyFatElement) {
        console.log('Missing required values:', { bmi, waist, hip, gender, bodyFatElement });
        return;
    }

    const whr = waist / hip;
    setDisplay('whr-display', whr, 2);

    // Calculate fat mass and lean mass
    const weight = getValue('weight');
    const fatMass = (bodyFatElement / 100) * weight;
    const leanMass = weight - fatMass;

    // Update body composition displays
    setDisplay('body-fat-display', bodyFatElement, 1);
    setDisplay('body-fat', bodyFatElement, 1);
    setDisplay('fat-mass-display', fatMass, 1);
    setDisplay('lean-mass-display', leanMass, 1);

    // Get risk assessment using the existing function
    const riskData = getHealthRiskAssessment(bmi, waistValue, whr, bodyFatElement, gender);


    if (!riskData) {
        console.log('No matching risk data found');
        return whr;
    }

    // Update display elements with new data structure
    const riskElement = document.getElementById('whr-risk');
    const messageElement = document.getElementById('health-risk-message');
    const waistCategoryElement = document.getElementById('waist-category');
    const whrCategoryElement = document.getElementById('whr-category');
    const bmiCategoryElement = document.getElementById('bmi-category');
    const bodyFatCategoryElement = document.getElementById('body-fat-category');
    // Update BMI category (use "Normal" instead of "Normal Weight")
    if (bmiCategoryElement) {
        let bmiCategory = riskData.bmi_category;
        if (bmiCategory === 'Normal Weight') {
            bmiCategory = 'Normal';
        }
        bmiCategoryElement.textContent = bmiCategory;
    }

    // Update waist category (use "Low Risk" terminology and include measurement)
    if (waistCategoryElement) {
        let waistCategory = riskData.waist_category;
        if (waistCategory === 'Low') {
            waistCategory = 'Low Risk';
        }
        waistCategoryElement.textContent = `${waistCategory} `;
        document.getElementById('Waist-display').textContent = `${waistValue.toFixed(2)}`
    }

    // Update WHR category (use "Low Risk" for safe ranges)
    if (whrCategoryElement) {
        let whrCategory = riskData.whr_category;
        if (whrCategory === 'Low') {
            whrCategory = 'Low Risk';
        }
        whrCategoryElement.textContent = whrCategory;
    }

    // Update body fat category
    if (bodyFatCategoryElement) {
        bodyFatCategoryElement.textContent = riskData.body_fat_category;
    }

    // Update overall risk display
    if (riskElement) {
        const overallRisk = determineOverallRisk(riskData);
        riskElement.textContent = overallRisk;
        riskElement.className = `whr-risk ${riskData.whr_category.toLowerCase().replace(' ', '-')}`;
    }

    // Update health message
    if (messageElement) {
        /*messageElement.textContent = riskData.suggested_message;
          messageElement.className = `health-message ${riskData.whr_category.toLowerCase().replace(' ', '-')}`;
          */
        let formattedMessage = riskData.suggested_message;

        messageElement.innerHTML = formattedMessage;
        messageElement.className = `health-message ${riskData.whr_category.toLowerCase().replace(' ', '-')}`;
    }

    // Store comprehensive data
    userData.whr = whr;
    userData.waist = waist;
    userData.hip = hip;
    userData.bodyFat = bodyFatElement;
    userData.fatMass = fatMass;
    userData.leanMass = leanMass;
    userData.bmiCategory = riskData.bmi_category;
    userData.waistCategory = riskData.waist_category;
    userData.whrCategory = riskData.whr_category;
    userData.bodyFatCategory = riskData.body_fat_category;
    userData.overallRisk = determineOverallRisk(riskData);
    userData.healthMessage = riskData.suggested_message;

    animateHealthSpeedometers();
    return whr;
}

function determineOverallRisk(riskData) {
    const categories = [riskData.waist_category, riskData.whr_category];

    // Special handling for severe underweight
    if (riskData.bmi_category === 'Severe Underweight') {
        return 'Critical - Medical Intervention Required';
    }

    // Special handling for essential fat
    if (riskData.body_fat_category === 'Essential Fat') {
        return 'Specialist Consultation Required';
    }

    // Count high risk categories
    const highRiskCount = categories.filter((cat) => cat && cat.toLowerCase().includes('high')).length;

    const moderateRiskCount = categories.filter((cat) => cat && cat.toLowerCase().includes('moderate')).length;

    if (highRiskCount >= 2) return 'High Risk';
    if (highRiskCount >= 1) return 'Moderate to High Risk';
    if (moderateRiskCount >= 1) return 'Moderate Risk';

    return 'Low Risk';
}
// Enhanced BMI calculation with visual feedback
function calculateBMI() {
    const weight = convertWeightToKg(); // Always returns kg
    const height = convertHeightToCm(); // Always returns cm

    if (weight > 0 && height > 0) {
        const heightInMeters = height / 100;
        const bmi = weight / (heightInMeters * heightInMeters);
        setDisplay('bmi-display', bmi, 1);

        // Update BMI category with styling
        let category = '';
        let className = '';
        if (bmi < 18.5) {
            category = 'Underweight';
            className = 'bmi-underweight';
        } else if (bmi < 25) {
            category = 'Normal Weight';
            className = 'bmi-normal';
        } else if (bmi < 30) {
            category = 'Overweight';
            className = 'bmi-overweight';
        } else {
            category = 'Obese';
            className = 'bmi-obese';
        }

        const categoryElement = document.getElementById('bmi-category');
        categoryElement.textContent = category;
        categoryElement.className = `bmi-category ${className}`;

        userData.bmi = bmi;
        userData.bmiCategory = category;

        // Generate body composition feedback
        // generateBodyCompositionFeedback(bmi, category);
        calculateComprehensiveHealthRisk();
        return bmi;
    }
    return 0;
}

// Enhanced RMR calculation with multiple formulas
function calculateRMR() {
    const weight = convertWeightToKg(); // Always returns kg
    const height = convertHeightToCm(); // Always returns cm
    const age = getValue('age');
    const gender = getRadioValue('biological-gender');
    const lbm = calculateLBM();

    if (weight > 0 && height > 0 && age > 0 && gender) {
        let rmr;

        // Use Katch-McArdle if we have body fat, otherwise Mifflin-St Jeor
        if (lbm > 0 && lbm !== weight) {
            // Katch-McArdle Formula (most accurate with body fat)
            rmr = 370 + 21.6 * lbm;
        } else {
            // Mifflin-St Jeor Formula
            if (gender === 'male') {
                rmr = 10 * weight + 6.25 * height - 5 * age + 5;
            } else {
                rmr = 10 * weight + 6.25 * height - 5 * age - 161;
            }
        }

        setDisplay('rmr-display', rmr, 0);
        userData.rmr = rmr;
        return rmr;
    }
    return 0;
}

function calculateLBM() {
    const weight = convertWeightToKg();
    const bodyFat = getValue('custom-body-fat');

    if (weight > 0 && bodyFat > 0) {
        const lbm = weight * ((100 - bodyFat) / 100);
        const fatMass = weight - lbm;
        setDisplay('lbm-display', lbm, 1);
        setDisplay('fat-mass-display', fatMass, 1);
        userData.lbm = lbm;
        userData.fatMass = fatMass;
        return lbm;
    }
    return 0;
}

function calculateNEAT() {
    const rmr = calculateRMR();

    const activityLevel = getRadioValue('activity-level');
    const gender = getRadioValue('biological-gender');

    if (rmr > 0 && activityLevel && gender) {
        const multiplier = ACTIVITY_MULTIPLIERS[gender][activityLevel] || 1;
        const neat = rmr * multiplier;

        setDisplay('neat-display', neat, 0);
        userData.neat = neat;
        return neat;
    }
    return 0;
}

function getAgeAdjustedMET(baseMET, age) {
    let ageAdjustmentFactor = 1.0; // Default for 18-29

    if (age >= 30 && age <= 39) ageAdjustmentFactor = 0.93;
    else if (age >= 40 && age <= 49) ageAdjustmentFactor = 0.95; // (100% - 12% = 88%, but table shows 0.95?)
    else if (age >= 50 && age <= 59) ageAdjustmentFactor = 0.83;
    else if (age >= 60 && age <= 69) ageAdjustmentFactor = 0.78;
    else if (age >= 70 && age <= 79) ageAdjustmentFactor = 0.72;
    else if (age >= 80) ageAdjustmentFactor = 0.67;

    return baseMET * ageAdjustmentFactor;
}

function calculateEAT() {
    const weight = convertWeightToKg();
    const dontExercise = document.getElementById('dont-exercise').checked;

    if (dontExercise) {
        setDisplay('eat-display', 0, 0);
        Object.keys(EXERCISE_MET).forEach((intensity) => {
            const caloriesId = intensity.replace('_', '-') + '-calories';
            const element = document.getElementById(caloriesId);
            if (element) element.textContent = '0';
        });
        userData.eat = 0;
        return 0;
    }

    let totalEAT = 0;

    if (weight > 0) {
        Object.keys(EXERCISE_MET).forEach((intensity) => {
            const minutesId = intensity.replace('_', '-') + '-minutes';
            const caloriesId = intensity.replace('_', '-') + '-calories';
            const minutes = getValue(minutesId);
            const caloriesElement = document.getElementById(caloriesId);

            if (minutes > 0) {
                //const met = EXERCISE_MET[intensity];
                const age = getValue('age');
                const baseMET = EXERCISE_MET[intensity];
                
                const met = getAgeAdjustedMET(baseMET, age);

                const weeklyCalories = (met * 3.5 * weight * minutes) / 200;
                const dailyCalories = weeklyCalories / 7;
                totalEAT += dailyCalories;
                if (caloriesElement) caloriesElement.textContent = Math.round(dailyCalories);
            } else {
                if (caloriesElement) caloriesElement.textContent = '0';
            }
        });
    }

    setDisplay('eat-display', totalEAT, 0);
    userData.eat = totalEAT;
    return totalEAT;
}

function calculateTEF() {
    const rmr = calculateRMR();
    const neat = calculateNEAT();
    const eat = calculateEAT();

    const tef = (rmr + neat + eat) * 0.1;
    setDisplay('tef-display', tef, 0);
    userData.tef = tef;
    return tef;
}
function calculateBMR() {
    let weight = Number(userData.weight) || 0
    let height = Number(userData.height) || 0
    let age = Number(userData.age) || 0
    let gender = userData.gender

    let bmr = 0

    if (weight && height && age && gender) {
        if (gender === 'male') {
            bmr = (10 * weight) + (6.25 * height) - (5 * age) + 5
        } else if (gender === 'female') {
            bmr = (10 * weight) + (6.25 * height) - (5 * age) - 161
        }
    }

    bmr = Math.round(bmr)

    userData.bmr = bmr
 

    //setDisplay('bmr-display', bmr, 0)

    return bmr
}

function calculateTDEE() {
    // Step 1: Calculate base components
    const rmr = calculateRMR();
    const neat = calculateNEAT();
    const eat = calculateEAT();
    const tef = calculateTEF();

    // Store initial values before applying multipliers
    let initialRmr = userData.rmr || 0;
    let initialNeat = userData.neat || 0;
    let initialEat = userData.eat || 0;
    let initialTef = userData.tef || 0;
    let initialBmi = userData.bmi || 0;
    let initialBodyFat = userData.bodyFat || 0;

    // Apply Sleep Impact
    const sleepAdequate = getRadioValue('adequate-sleep');
    const sleepDuration = getRadioValue('sleep-duration');
    let sleepMultiplier = SLEEP_IMPACT.yes; // Default to no impact if adequate sleep

    if (sleepAdequate === 'no' && sleepDuration && SLEEP_IMPACT.no[sleepDuration]) {
        sleepMultiplier = SLEEP_IMPACT.no[sleepDuration];
    }

    initialRmr *= sleepMultiplier.rmr;
    initialNeat *= sleepMultiplier.neat;
    initialEat *= sleepMultiplier.eat;
    initialTef *= sleepMultiplier.tef;
    initialBmi *= sleepMultiplier.bmi;
    initialBodyFat *= sleepMultiplier.bodyFat;

    // Apply Alcohol Impact
    const alcoholConsumption = getRadioValue('alcohol-consumption');
    const alcoholTier = getRadioValue('alcohol-tier');
    let alcoholMultiplier = ALCOHOL_IMPACT.none;

    if (alcoholConsumption === 'yes' && alcoholTier && ALCOHOL_IMPACT[alcoholTier]) {
        alcoholMultiplier = ALCOHOL_IMPACT[alcoholTier];
    }

    initialRmr *= alcoholMultiplier.rmr;
    initialNeat *= alcoholMultiplier.neat;
    initialEat *= alcoholMultiplier.eat;
    initialTef *= alcoholMultiplier.tef;
    initialBmi *= alcoholMultiplier.bmi;
    initialBodyFat *= alcoholMultiplier.bodyFat;

    // Apply Smoking Impact
    const smokingStatus = getRadioValue('smoking-habit');
    const smokingTier = getRadioValue('smoking-tier');
    let smokingMultiplier = SMOKING_IMPACT.no;

    if (smokingStatus === 'yes' && smokingTier && SMOKING_IMPACT.yes[smokingTier]) {
        smokingMultiplier = SMOKING_IMPACT.yes[smokingTier];
    }

    initialRmr *= smokingMultiplier.rmr;
    initialNeat *= smokingMultiplier.neat;
    initialEat *= smokingMultiplier.eat;
    // TEF is not impacted by smoking, so no multiplier for initialTef
    initialBmi *= smokingMultiplier.bmi;
    initialBodyFat *= smokingMultiplier.bodyFat;

    // Update userData with adjusted values
    userData.rmr = initialRmr;
    userData.neat = initialNeat;
    userData.eat = initialEat;
    userData.tef = initialTef;
    userData.bmi = initialBmi;
    userData.bodyFat = initialBodyFat;

    // Recalculate TDEE with adjusted components
    let tdee = (userData.rmr || 0) + (userData.neat || 0) + (userData.eat || 0) + (userData.tef || 0);
    userData.tdee = tdee;
    setDisplay('tdee-display', tdee, 0);

    updateCombinedCircularProgress(initialRmr, initialNeat, initialEat, initialTef, tdee);

    return tdee;
}

let chart;


function initChart() {
    const ctx = document.getElementById('donut_chart').getContext('2d');

    // Plugin for external labels with lines
    const externalLabelsPlugin = {
        id: 'externalLabels',
        afterDatasetsDraw(chart) {
            const { ctx, data } = chart;
            const meta = chart.getDatasetMeta(0);

            ctx.save();

            data.datasets[0].data.forEach((value, index) => {
                const element = meta.data[index];
                if (!element) return;

                const { x: centerX, y: centerY } = element;
                const radius = element.outerRadius;

                // total for percentage
                const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;

                // middle angle of arc
                const angle = (element.startAngle + element.endAngle) / 2;

                // line start at arc edge
                const lineStartX = centerX + Math.cos(angle) * radius;
                const lineStartY = centerY + Math.sin(angle) * radius;

                // line end further out
                const lineLength = 20;
                const lineEndX = centerX + Math.cos(angle) * (radius + lineLength);
                const lineEndY = centerY + Math.sin(angle) * (radius + lineLength);


                ctx.beginPath();
                ctx.strokeStyle = '#666';
                ctx.lineWidth = 2;
                ctx.moveTo(lineStartX, lineStartY); // start at arc

                let cornerOffset = 15;


                let midX = lineStartX + Math.cos(angle) * cornerOffset;
                let midY = lineStartY + Math.sin(angle) * cornerOffset;
                ctx.lineTo(midX, midY);


                let finalX = lineEndX + (lineEndX > centerX ? 20 : -20);
                ctx.lineTo(finalX, midY);

                ctx.stroke();


                const label = data.labels[index];
                const labelText = `${label}: ${percentage}%`;
                ctx.font = 'bold 14px sans-serif';
                ctx.fillStyle = '#333';

                let labelOffset = 30;
                ctx.textAlign = lineEndX > centerX ? 'left' : 'right';
                ctx.fillText(
                    labelText,
                    lineEndX > centerX ? lineEndX + labelOffset : lineEndX - labelOffset,
                    midY + 4
                );
            });

            ctx.restore();
        }
    };

    chart = new Chart(ctx, {
    type: 'pie',
    data: {
        labels: ['RMR', 'NEAT', 'EAT', 'TEF'],
        datasets: [{
            data: [0, 0, 0, 0],
            backgroundColor: ['#2563EB', '#16A34A', '#EA580C', '#9333EA'],
            borderWidth: 2,
            borderColor: '#fff'
        }]
    },
    options: {
        responsive: false,
        maintainAspectRatio: true,
        width: 500,
        height: 500,
        // cutout: '60%',

        layout: {
            padding: 90
        },
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: true
            }
        }
    },
    animation: {
        animateRotate: true,
        animateScale: false,
        duration: 1000
    },
    plugins: [externalLabelsPlugin]
});

}



initChart();


function updateCombinedCircularProgress(rmr, neat, eat, tef, tdee) {
    // Calculate percentages
    const rmrPercentage = tdee > 0 ? (rmr / tdee) * 100 : 0;
    const neatPercentage = tdee > 0 ? (neat / tdee) * 100 : 0;
    const eatPercentage = tdee > 0 ? (eat / tdee) * 100 : 0;
    const tefPercentage = tdee > 0 ? (tef / tdee) * 100 : 0;

    // Update Chart.js data
    if (chart) {
        chart.data.datasets[0].data = [rmr, neat, eat, tef];
        chart.update();
    }

    // Update displays in boxes (keep your existing code)
    document.getElementById('tdee-display').textContent = tdee.toFixed(2) + ' cal/day';
    document.getElementById('rmr-display').textContent = rmr.toFixed(2);
    document.getElementById('neat-display').textContent = neat.toFixed(2);
    document.getElementById('eat-display').textContent = eat.toFixed(2);
    document.getElementById('tef-display').textContent = tef.toFixed(2);

    // Update percentages in boxes (keep your existing code)
    document.getElementById('rmr-percentage').textContent = rmrPercentage.toFixed(2) + '%';
    document.getElementById('neat-percentage').textContent = neatPercentage.toFixed(2) + '%';
    document.getElementById('eat-percentage').textContent = eatPercentage.toFixed(2) + '%';
    document.getElementById('tef-percentage').textContent = tefPercentage.toFixed(2) + '%';
}

function calculateNutritionForMultipleGoals() {
    const tdee = calculateTDEE();
    const lbm = calculateLBM();
    const weight = convertWeightToKg();
    const selectedGoals = getSelectedGoals();
console.log(selectedGoals)
    if (selectedGoals.length === 0) return;

    let goalData;

    if (selectedGoals.length === 1) {
        goalData = FITNESS_GOALS[selectedGoals[0]];
    } else if (selectedGoals.length === 2) {
        // Blend the two goals
        const goal1 = FITNESS_GOALS[selectedGoals[0]];
        const goal2 = FITNESS_GOALS[selectedGoals[1]];
        goalData = {
            multiplier: (goal1.multiplier + goal2.multiplier) / 2,
            protein: Math.max(goal1.protein, goal2.protein),
            fat: (goal1.fat + goal2.fat) / 2,
            name: `${goal1.name} + ${goal2.name}`,
        };
    }

    // Target calories
    const targetCalories = tdee * goalData.multiplier;
    setDisplay('target-calories-display', targetCalories, 0);

    // Protein calculation
    const proteinGrams = lbm * goalData.protein;
    setDisplay('protein-display', proteinGrams, 1);

    // Fat calculation
    const fatGrams = weight * goalData.fat;
    setDisplay('fat-display', fatGrams, 1);

    // Carb calculation (remaining calories)
    const proteinCalories = proteinGrams * 4;
    const fatCalories = fatGrams * 9;
    const carbCalories = targetCalories - proteinCalories - fatCalories;
    const carbGrams = carbCalories / 4;
    setDisplay('carb-display', carbGrams, 1);

    // Store nutrition data
    userData.targetCalories = targetCalories;
    userData.protein = proteinGrams;
    userData.carbs = carbGrams;
    userData.fats = fatGrams;
    userData.selectedGoals = selectedGoals;

    // Update recommendations

    updateRecommendationsForMultipleGoals(selectedGoals);
}


function updateRecommendationsForMultipleGoals(goals) {
    const recommendations = {
       lose_fat_maintain_muscle: {
    title: '🔥 Lose Fat & Maintain Muscle',
    subtitle: 'Preserve lean mass while in a caloric deficit',
    trainingSection: {
        title: '🏋️ Training Split',
        content: [
            `
            <h3>💪 Strength:</h3>
            <ul>
            <li>3–4x/week | 2–4 sets × 6–12 reps @ 65–85% 1RM</li>
            <li>Compounds (squats, deadlifts, presses, rows) + accessories</li>
            <li><strong>Rest</strong>: 60–90s (hypertrophy), 2–3 min (heavy lifts)</li>
            <li><strong>Progression</strong>: +2–5% load when form is solid</li>
            <li><strong>Goal</strong>: Stimulate MPS and preserve lean mass during deficit</li>
            </ul>
            `,
            
            `
            <h3>🏃 Cardio:</h3>
            <ul>
            <li>3–5x/week</li>
            <li><strong>LISS</strong>: 30–45 min @ 60–70% HRmax OR</li>
            <li><strong>HIIT</strong>: 20–25 min (30s sprint/90s walk × 8–12 rounds)</li>
            <li><strong>Progression</strong>: Increase duration (LISS) or rounds (HIIT) once manageable</li>
            <li><strong>Tip</strong>: Cardio after lifting; rotate modalities to reduce joint stress</li>
            </ul>
            `
        ]
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>🥩 Protein:</strong> 1.6–2.2 g/kg/day (e.g., 112–154g for 70kg)</li>
        <li><strong>📉 Caloric deficit:</strong> 250–500 kcal/day</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: Waist circumference, strength, visuals',
            '🔄 Periodize training: Alternate high-intensity and recovery weeks',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },

supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
},
},
lose_fat_gain_muscle: {
    title: '⚖️ Body Recomposition (Lose Fat & Gain Muscle)',
    subtitle: 'Simultaneous fat loss and muscle gain',
    trainingSection: {
        title: '🏋️ Training Split',
        content: [
            `
            <h3>💪 Strength:</h3>
            <ul>
            <li>3–5x/week | 3–4 sets × 8–12 reps @ 65–80% 1RM</li>
            <li>Compounds + isolation (lateral raises, curls)</li>
            <li><strong>Rest</strong>: 60–90s (hypertrophy), 2–3 min (compounds)</li>
            <li><strong>Progression</strong>: +2–5% or add reps/sets when prescribed work is completed with good form</li>
            <li><strong>Goal</strong>: Stimulate hypertrophy while maintaining metabolic demand for fat loss</li>
            </ul>
            `,
            
            `
            <h3>🏃 Cardio:</h3>
            <ul>
            <li>2–4x/week</li>
            <li><strong>LISS</strong>: 30–45 min @ 65–70% HRmax OR</li>
            <li><strong>HIIT</strong>: 1–2x/week (30s sprint/90s walk × 6–10 rounds)</li>
            <li><strong>Progression</strong>: Gradually increase duration (LISS) or rounds (HIIT) if recovery and strength unaffected</li>
            <li><strong>Goal</strong>: Support fat loss and insulin sensitivity without compromising muscle retention</li>
            </ul>
            `
        ]
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>🥩 Protein:</strong> 1.8–2.4 g/kg/day (e.g., 126–168g for 70kg)</li>
        <li><strong>🔄 Cycle:</strong> Mild deficit ↔ maintenance phases</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: Strength gains, body measurements',
            '🔄 Periodize training: Alternate high-intensity and recovery weeks',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },
 supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
}
},

      maintain: {
    title: '🧘‍♂️ ⚖️ Maintain Current Weight & Composition',
    subtitle: 'Support lean mass, metabolic health, and performance without weight change',
    trainingSection: {
        title: '🏋️ Training Split',
        content: [
            `
            <h3>💪 Strength:</h3>
            <ul>
            <li>2–4x/week | 2–3 sets × 8–12 reps @ 60–75% 1RM</li>
            <li>Compounds + accessories for strength retention</li>
            <li><strong>Rest</strong>: 60–90s (maintenance), 2–3 min (heavy lifts)</li>
            <li><strong>Progression</strong>: Adjust load or reps slightly to maintain strength and prevent detraining</li>
            <li><strong>Goal</strong>: Maintain muscle mass, strength, and metabolic health</li>
            </ul>
            `,
            
            `
            <h3>🏃 Cardio:</h3>
            <ul>
            <li>2–4x/week</li>
            <li><strong>LISS</strong>: 30–45 min @ 60–70% HRmax OR</li>
            <li><strong>Moderate aerobic</strong>: 30–40 min @ 65–75% HRmax</li>
            <li><strong>Progression</strong>: Increase duration or intensity slightly if performance goals expand</li>
            <li><strong>Goal</strong>: Support cardiovascular health, insulin sensitivity, and energy balance</li>
            </ul>
            `
        ]
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>🥩 Protein:</strong> 1.4–2.0 g/kg/day (e.g., 98–140g for 70kg)</li>
        <li><strong>⚖️ Energy balance:</strong> Calories in ≈ calories out</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: Performance metrics > weight alone',
            '🔄 Periodize training: Alternate high-intensity and recovery weeks',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },
   supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
}
},

       gain_muscle: {
    title: '💪 Gain Muscle Mass',
    subtitle: 'Progressive overload + high protein intake = lean tissue growth',
    trainingSection: {
        title: '🏋️ Training Split',
        content: [
            `
            <h3>💪 Strength:</h3>
            <ul>
            <li>4–6x/week (Push/Pull/Legs or Upper/Lower)</li>
            <li>3–5 sets × 6–12 reps @ 65–85% 1RM</li>
            <li>Compounds + isolation for weak points</li>
            <li><strong>Rest</strong>: 60–90s (hypertrophy), 2–3 min (strength blocks)</li>
            <li><strong>Progression</strong>: +2–5% weekly or add sets/reps once prescribed work is completed with good form</li>
            <li><strong>Goal</strong>: Maximize MPS and hypertrophy through progressive overload</li>
            </ul>
            `,
            
            `
            <h3>🏃 Cardio:</h3>
            <ul>
            <li>1–2x/week (minimal to preserve recovery)</li>
            <li><strong>LISS</strong>: 20–30 min @ 60–70% HRmax OR</li>
            <li><strong>HIIT</strong>: ≤15 min (20s sprint/100s walk × 6–8 rounds)</li>
            <li><strong>Progression</strong>: Increase duration slightly if recovery and strength unaffected</li>
            <li><strong>Goal</strong>: Support cardiovascular health without impairing recovery or hypertrophy</li>
            </ul>
            `
        ]
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>🥩 Protein:</strong> 1.6–2.4 g/kg/day (e.g., 112–168g for 70kg)</li>
        <li><strong>📈 Caloric surplus:</strong> 250–500 kcal/day</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: Strength gains, circumferences, lean mass',
            '🔄 Periodize training: Alternate high-intensity and recovery weeks',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },
    supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
}
},
        get_faster: {
    title: '🏃‍♂️ Improve Endurance Performance',
    subtitle: 'Boost VO₂ max, lactate threshold, and muscular stamina',
    trainingSection: {
        title: '🏋️ Training Split',
        content: [
            `
            <h3>💪 Strength (Supportive):</h3>
            <ul>
            <li>2x/week | 2–3 sets × 12–15 reps</li>
            <li>Full-body circuits, low-load for injury prevention</li>
            <li><strong>Rest</strong>: 60–90s</li>
            <li><strong>Progression</strong>: Gradually increase reps or circuit density to build muscular stamina</li>
            <li><strong>Goal</strong>: Injury prevention, muscular endurance, and joint stability</li>
            </ul>
            `,
            
            `
            <h3>🏃 Cardio:</h3>
            <ul>
            <li>4–6x/week</li>
            <li><strong>Zone 2</strong>: 60–75 min @ 60–70% HRmax (aerobic base)</li>
            <li><strong>Tempo</strong>: 20–40 min @ 80–85% HRmax (lactate threshold)</li>
            <li><strong>VO₂ max intervals</strong>: 4–6 × 3–5 min @ 90–95% HRmax</li>
            <li><strong>Progression</strong>: Increase duration or intensity gradually; periodize with recovery weeks</li>
            <li><strong>Goal</strong>: Improve aerobic efficiency, lactate threshold, and VO₂ max</li>
            </ul>
            `
        ]
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>🥩 Protein:</strong> 1.4–1.8 g/kg/day (e.g., 98–126g for 70kg)</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>⚖️ Caloric approach:</strong> Maintain adequate intake to fuel high training volume</li>
        <li><strong>💧 Intra-session:</strong> BCAA + electrolytes for runs >60 min</li>
        <li><strong>🍌 Post-workout:</strong> Protein + carbs for glycogen replenishment</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: VO₂ max, lactate threshold, recovery metrics',
            '🔄 Periodize training: Alternate high-intensity and recovery weeks',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },
    supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
}
},

      increase_strength: {
    title: '🏋️‍♂️ Increase Strength & Power',
    subtitle: 'Maximize force output, neural efficiency, and lean mass',
    trainingSection: {
        title: '🏋️ Training Split',
        content: [
            `
            <h3>💪 Strength:</h3>
            <ul>
            <li>3–5x/week (Upper/Lower or Full-Body Power)</li>
            <li>3–6 sets × 3–6 reps @ 80–95% 1RM</li>
            <li><strong>Compounds</strong>: Squats, deadlifts, bench, cleans, OHP</li>
            <li><strong>Rest</strong>: 2–4 min for neural recovery</li>
            <li><strong>Progression</strong>: Linear or wave loading; track bar speed, RPE, and total volume for CNS monitoring</li>
            <li><strong>Goal</strong>: Maximize force output, neural efficiency, and lean mass</li>
            </ul>
            `,
            
            `
            <h3>🏃 Cardio:</h3>
            <ul>
            <li>1–2x/week (minimal)</li>
            <li><strong>HIIT</strong>: ≤15 min (sled pushes, hill sprints)</li>
            <li><strong>Progression</strong>: Add rounds or intensity only if recovery and strength unaffected</li>
            <li><strong>Goal</strong>: Maintain conditioning without impairing strength recovery</li>
            </ul>
            `
        ]
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>🥩 Protein:</strong> 1.6–2.2 g/kg/day (e.g., 112–154g for 70kg)</li>
        <li><strong>🛌 Prioritize:</strong> Post-workout nutrition + sleep for CNS recovery</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: Bar speed, total volume, RPE',
            '🔄 Periodize training: Alternate high-intensity and recovery weeks',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },
   supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
}
},
       recovering_injury: {
    title: '🩺 Recovery from Injury',
    subtitle: 'Support tissue healing, reduce inflammation, and preserve lean mass',
    trainingSection: {
        title: '🏋️ Rehabilitation Focus',
        content: [
            `
            <h3>🧘 Daily Gentle Movement:</h3>
            <ul>
            <li>As tolerated: PT, isometric holds, mobility</li>
            <li><strong>Progression</strong>: Gradual reintroduction of load and movement complexity under professional guidance</li>
            <li><strong>Goal</strong>: Restore range of motion, neuromuscular control, and circulation</li>
            </ul>
            `,
            
            `
            <h3>💪 Modified Strength:</h3>
            <ul>
            <li>2–3x/week | 2–3 sets × 10–15 reps (if cleared by rehab professional)</li>
            <li>Unilateral work, bands, tempo control</li>
            <li><strong>Progression</strong>: Increase resistance or complexity only when pain-free and cleared</li>
            <li><strong>Goal</strong>: Prevent atrophy, stimulate blood flow, maintain neuromuscular pathways</li>
            </ul>
            `
        ]
    },
    recoverySection: {
        title: '🛌 Recovery Priorities',
        content: `
        <ul>
        <li><strong>😴 Sleep:</strong> 8–9 hrs/night for tissue regeneration</li>
        <li><strong>💧 Hydration:</strong> 2.5–3.5 L/day</li>
        <li><strong>🥗 Anti-inflammatory foods:</strong> Omega-3s, berries, turmeric, fatty fish</li>
        </ul>
        `
    },
    nutritionSection: {
        title: '🍽️ Nutrition',
        content: `
        <ul>
        <li><strong>🥗 Food first:</strong> Prioritize whole foods (lean meats, fish, eggs, dairy, legumes, tofu, tempeh, beans) & fibre-rich foods per your dietary preference. Supplements fill gaps, never replace.</li>
        <li><strong>⚡ Leucine threshold:</strong> ~2.5g per serving triggers Muscle Protein Synthesis (MPS)</li>
        <li><strong>🥩 Protein:</strong> 1.6–2.2 g/kg/day (e.g., 112–154g for 70kg)</li>
        <li><strong>🩹 Supports:</strong> Collagen synthesis, immune function, muscle preservation</li>
        <li><strong>⚡ BCAA:</strong> Useful during immobilization to preserve lean mass</li>
        <li><strong>🧬 Creatine:</strong> Supports muscle retention + cognitive resilience during rehab</li>
        </ul>
        `
    },
    practicalTipsSection: {
        title: '💡 Practical Tips',
        content: [
            '📊 Track: Pain levels, mobility, strength benchmarks',
            '🔄 Periodize training: Alternate intensities and prioritize recovery',
            '💧 Use intra-session BCAA + Electrolytes for runs >60 min or in humid conditions',
            '🍌 Combine protein supplements with carbs post-training for glycogen replenishment',
            '🔀 Rotate protein sources for amino acid diversity',
        ]
    },
    supplementFrameworkSection: {
    title: '🧪 Supplement Framework',
    content: [
        {
            emoji: '🧬',
            name: 'Creatine',
            dosage: '3–5g daily (anytime)',
            benefits: 'strength, ATP, lean mass',
            purpose: 'Boost ATP, strength & lean mass',
            product: {
                title: 'MESH Creatine 200',
                url: '/products/authayn-mesh-creatine',
                image: '/cdn/shop/files/Protein_studio-058_197f0731-841e-4bc1-9dee-6ea85cc826ba.png?v=1765351941&width=823'
            }
        },
        {
            emoji: '⚡',
            name: 'BCAA + Electrolytes',
            dosage: '5–10g pre/intra-workout',
            benefits: 'fasted training, hot climates, hydration',
            purpose: 'Hydration, reduce fatigue, prime MPS',
            product: {
                title: 'BCAA + Electrolytes',
                url: '/products/authayn-bcaa-electrolytes',
                image: '/cdn/shop/files/Protein_studio-052_99383e17-d92e-4aa8-946d-cec7d89ea866.png'
            }
        },
        {
            emoji: '🥤',
            name: 'Protein',
            dosage: 'Morning (20–30g), post-workout (25–40g), evening (20–35g)',
            typeDetails: [
                {
                    type: 'Whey isolate',
                    description: 'Fast, ~2.7g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Whey Concentrate or Whey blends',
                    description: 'Fast, ~2.6g leucine/~25g',
                    product: {
                        title: 'Whey ISO90',
                        url: '/products/authayn-whey-isolate',
                        image: '/cdn/shop/files/Front.png'
                    }
                },
                {
                    type: 'Soy protein',
                    description: 'complete, ~2.5g leucine/~25g',
                    product: {
                        title: 'Soy Protein Isolate',
                        url: '/products/authayn-whey-soy-iso',
                        image: '/cdn/shop/files/Protein_studio-018_1.png'
                    }
                },
                {
                    type: 'Plant blends/Casein',
                    description: 'slow-release, overnight recovery',
                    product: {
                        title: 'Plant Protein Isolate',
                        url: '/products/authayn-whey-plant-iso',
                        image: '/cdn/shop/files/Protein_studio-009_2_ac98876c-99a7-4ef5-a2d0-ba78bd160315.png'
                    }
                }
            ]
        }
    ]
}
},
    };

    displayRecommendations(goals, recommendations);
}


function displayRecommendations(goals, recommendations) {
    const list = document.getElementById('recommendations-list');
    if (list) {
        list.innerHTML = '';

        goals.forEach((goal, index) => {
            if (recommendations[goal]) {
                const goalData = recommendations[goal];

                // Create goal section container
                const goalSection = document.createElement('div');
                goalSection.className = 'goal-section';

                // Create wrapper div for all content
                const contentWrapper = document.createElement('div');
                contentWrapper.className = 'content-wrapper bg-border';

                const contentBg = document.createElement('div');
                contentBg.className = 'bg-border';
                
                // Goal title
                const goalTitle = document.createElement('div');
                goalTitle.className = 'goal-title';
                goalTitle.innerHTML = goalData.title;
                contentBg.appendChild(goalTitle);

                // Subtitle
                if (goalData.subtitle) {
                    const subtitle = document.createElement('div');
                    subtitle.className = 'goal-subtitle';
                    subtitle.textContent = goalData.subtitle;
                    contentBg.appendChild(subtitle);
                }

                contentWrapper.appendChild(contentBg);

                // -------------------- Training Split Section --------------------
                if (goalData.trainingSection) {
                    const trainingSectionDiv = document.createElement('div');
                    trainingSectionDiv.className = 'training-section';

                    const trainingTitle = document.createElement('h3');
                    trainingTitle.className = 'section-main-header bg-image';
                    trainingTitle.textContent = goalData.trainingSection.title;
                    trainingSectionDiv.appendChild(trainingTitle);

                    goalData.trainingSection.content.forEach((contentHTML) => {
                        const contentDiv = document.createElement('div');
                        contentDiv.className = 'section-content';
                        contentDiv.innerHTML = contentHTML;
                        trainingSectionDiv.appendChild(contentDiv);
                    });

                    contentWrapper.appendChild(trainingSectionDiv);
                }

                // -------------------- Recovery & Nutrition Container (for injury recovery) --------------------
                if (goalData.recoverySection || goalData.nutritionSection) {
                    // Create main heading for Recovery/Mobility/Nutrition Essentials
                    const essentialsHeading = document.createElement('div');
                    essentialsHeading.className = 'essentials-heading';
                    essentialsHeading.textContent = goalData.recoverySection 
                        ? 'Recovery | Mobility | Nutrition Essentials' 
                        : 'Nutrition Essentials';
                    contentWrapper.appendChild(essentialsHeading);

                    // Create container for recovery and nutrition sections
                    const essentialsContainer = document.createElement('div');
                    essentialsContainer.className = goalData.recoverySection 
                        ? 'essentials-grid' 
                        : 'essentials-full';

                    // Recovery Section (for injury recovery)
                    if (goalData.recoverySection) {
                        const recoveryDiv = document.createElement('div');
                        recoveryDiv.className = 'recovery-section';

                        const recoveryTitle = document.createElement('h3');
                        recoveryTitle.className = 'section-sub-header';
                        recoveryTitle.textContent = goalData.recoverySection.title;
                        recoveryDiv.appendChild(recoveryTitle);

                        const recoveryContent = document.createElement('div');
                        recoveryContent.className = 'section-content';
                        recoveryContent.innerHTML = goalData.recoverySection.content;
                        recoveryDiv.appendChild(recoveryContent);

                        essentialsContainer.appendChild(recoveryDiv);
                    }

                    // Nutrition Section
                    if (goalData.nutritionSection) {
                        const nutritionDiv = document.createElement('div');
                        nutritionDiv.className = 'nutrition-section';

                        const nutritionTitle = document.createElement('h3');
                        nutritionTitle.className = 'section-sub-header';
                        nutritionTitle.textContent = goalData.nutritionSection.title;
                        nutritionDiv.appendChild(nutritionTitle);

                        const nutritionContent = document.createElement('div');
                        nutritionContent.className = 'section-content';
                        nutritionContent.innerHTML = goalData.nutritionSection.content;
                        nutritionDiv.appendChild(nutritionContent);

                        essentialsContainer.appendChild(nutritionDiv);
                    }

                    contentWrapper.appendChild(essentialsContainer);
                }

                // -------------------- Practical Tips Section --------------------
                if (goalData.practicalTipsSection) {
                    const practicalTipsHeading = document.createElement('div');
                    practicalTipsHeading.className = 'practical-tips-heading';
                    practicalTipsHeading.textContent = 'Practical Tips';
                    contentWrapper.appendChild(practicalTipsHeading);

                    const tipsDiv = document.createElement('div');
                    tipsDiv.className = 'practical-tips-section';

                    goalData.practicalTipsSection.content.forEach((tip) => {
                        const tipItem = document.createElement('div');
                        tipItem.className = 'tip-item';
                        tipItem.textContent = tip;
                        tipsDiv.appendChild(tipItem);
                    });

                    contentWrapper.appendChild(tipsDiv);
                }

                // -------------------- Supplement Framework Section --------------------
                if (goalData.supplementFrameworkSection) {
                    const supplementHeading = document.createElement('div');
                    supplementHeading.className = 'supplement-heading';
                    supplementHeading.textContent = 'Supplementation Framework';
                    contentWrapper.appendChild(supplementHeading);

                    const frameworkDiv = document.createElement('div');
                    frameworkDiv.className = 'supplement-framework-section';

                    goalData.supplementFrameworkSection.content.forEach((item) => {
                        const itemDiv = document.createElement('div');
                        itemDiv.className = 'framework-item';
                        
                        // Handle all supplements with standard format
                        if (item.emoji && item.name) {
                            const headerDiv = document.createElement('div');
                            headerDiv.className = 'supplement-header';
                            
                            const textContent = document.createElement('div');
                            textContent.className = 'supplement-text';
                            
                            // Build the content HTML
                            let contentHTML = `<div class="supplement-name">${item.emoji} ${item.name}</div>`;
                            contentHTML += `<div class="supplement-details">`;
                            contentHTML += `<div class="supplement-dosage">${item.dosage}</div>`;
                            
                            // Add purpose only if it exists (for Creatine and BCAA)
                            if (item.purpose) {
                                contentHTML += `<div class="supplement-purpose">${item.purpose}</div>`;
                            }
                            contentHTML += `</div>`;
                            
                            textContent.innerHTML = contentHTML;
                            headerDiv.appendChild(textContent);
                            
                            // Add product image and link (for Creatine and BCAA only)
                            if (item.product && !item.typeDetails) {
                                const productLink = document.createElement('a');
                                productLink.href = item.product.url;
                                productLink.target = '_blank';
                                productLink.className = 'product-link';
                                
                                const productImg = document.createElement('img');
                                productImg.src = item.product.image;
                                productImg.alt = item.product.title;
                                productImg.className = 'product-image';
                                
                                productLink.appendChild(productImg);
                                headerDiv.appendChild(productLink);
                            }
                            
                            // For Protein with typeDetails, add a placeholder product image
                            if (item.typeDetails && item.typeDetails.length > 0 && item.typeDetails[0].product) {
                                const productLink = document.createElement('a');
                                productLink.href = item.typeDetails[3].product.url;
                                productLink.target = '_blank';
                                productLink.className = 'product-link';
                                
                                const productImg = document.createElement('img');
                                productImg.src = item.typeDetails[3].product.image;
                                productImg.alt = item.typeDetails[3].product.title;
                                productImg.className = 'product-image';
                                
                                productLink.appendChild(productImg);
                                headerDiv.appendChild(productLink);
                            }
                            
                            itemDiv.appendChild(headerDiv);
                            
                            // Type Details section for Protein
                            if (item.typeDetails) {
                                const proteinTypesWrapper = document.createElement('div');
                                proteinTypesWrapper.className = 'protein-types-wrapper';
                                
                                const typesLabel = document.createElement('div');
                                typesLabel.className = 'protein-types-label';
                                typesLabel.innerHTML = `<strong>📋 Types:</strong>`;
                                proteinTypesWrapper.appendChild(typesLabel);
                                
                                const typesContent = document.createElement('div');
                                typesContent.className = 'protein-types-content';
                                
                                const typesTextContainer = document.createElement('div');
                                typesTextContainer.className = 'protein-types-text';
                                
                                item.typeDetails.forEach((detail, idx) => {
                                    const typeText = document.createElement('div');
                                    typeText.className = 'protein-type-item';
                                    typeText.innerHTML = `<strong>${detail.type}</strong> <span>(${detail.description})</span>`;
                                    if (idx < item.typeDetails.length - 1) {
                                        typeText.innerHTML += ',';
                                    }
                                    typesTextContainer.appendChild(typeText);
                                });
                                
                                typesContent.appendChild(typesTextContainer);
                                
                                // Add all product images in a column on the right
                                const productsColumn = document.createElement('div');
                                productsColumn.className = 'protein-products-column';
                                
                               item.typeDetails.forEach((detail, index) => {
    if (index === item.typeDetails.length - 1) return; // Skip last item
    
    if (detail.product) {
        const productLink = document.createElement('a');
        productLink.href = detail.product.url;
        productLink.target = '_blank';
        productLink.className = 'protein-product-link';
        productLink.title = detail.product.title;
        
        const productImg = document.createElement('img');
        productImg.src = detail.product.image;
        productImg.alt = detail.product.title;
        productImg.className = 'protein-product-image';
        
        productLink.appendChild(productImg);
        productsColumn.appendChild(productLink);
    }
});
                                
                                typesContent.appendChild(productsColumn);
                                proteinTypesWrapper.appendChild(typesContent);
                                itemDiv.appendChild(proteinTypesWrapper);
                            }
                        }
                        
                        frameworkDiv.appendChild(itemDiv);
                    });

                    contentWrapper.appendChild(frameworkDiv);
                }

                // Append contentWrapper to goalSection
                goalSection.appendChild(contentWrapper);

                // -------------------- Supplement Timing Table --------------------
                if (goalData.supplementTiming) {
                    const tableSection = document.createElement('div');
                    tableSection.className = 'table-section bg-border';

                    const tableTitle = document.createElement('div');
                    tableTitle.className = 'section-header';
                    tableTitle.textContent = goalData.supplementTiming.title;
                    tableSection.appendChild(tableTitle);

                    const table = document.createElement('table');
                    table.className = 'supplement-table bg-border';

                    // Create header row
                    const thead = document.createElement('thead');
                    const headerRow = document.createElement('tr');
                    goalData.supplementTiming.headers.forEach((header) => {
                        const th = document.createElement('th');
                        th.textContent = header;
                        headerRow.appendChild(th);
                    });
                    thead.appendChild(headerRow);
                    table.appendChild(thead);

                    // Create data rows
                    const tbody = document.createElement('tbody');
                    goalData.supplementTiming.data.forEach((row) => {
                        const tr = document.createElement('tr');
                        row.forEach((cell, cellIndex) => {
                            const td = document.createElement('td');
                            
                            // Check if this is the first cell and it contains product data (array)
                            if (cellIndex === 0 && Array.isArray(cell)) {
                                // This is the products array in the first column
                                cell.forEach(product => {
                                    const container = document.createElement('div');
                                    container.style.display = 'flex';
                                    container.style.alignItems = 'center';
                                    container.style.justifyContent = 'center';
                                    container.style.gap = '8px';

                                    // Product image with link
                                    if (product.image && product.url) {
                                        const imgLink = document.createElement('a');
                                        imgLink.href = product.url;
                                        imgLink.target = '_blank';
                                        imgLink.style.display = 'inline-flex';

                                        const img = document.createElement('img');
                                        img.src = product.image;
                                        img.alt = product.title || '';
                                        img.style.width = '40px';
                                        img.style.height = '40px';
                                        img.style.objectFit = 'contain';
                                        img.style.borderRadius = '4px';
                                        imgLink.appendChild(img);
                                        container.appendChild(imgLink);
                                    }

                                    td.appendChild(container);
                                });
                            } else {
                                // Regular text content
                                td.textContent = cell;
                            }
                            tr.appendChild(td);
                        });
                        tbody.appendChild(tr);
                    });
                    table.appendChild(tbody);

                    tableSection.appendChild(table);
                    goalSection.appendChild(tableSection);
                }

                list.appendChild(goalSection);
            }
        });
    }
}
/*function displayRecommendations(goals, recommendations) {
    const list = document.getElementById('recommendations-list');
    if (list) {
        list.innerHTML = '';

        goals.forEach((goal, index) => {
            if (recommendations[goal]) {
                const goalData = recommendations[goal];

                // Create goal section container
                const goalSection = document.createElement('div');
                goalSection.className = 'goal-section';

                // Create wrapper div for all content
                const contentWrapper = document.createElement('div');
                contentWrapper.className = 'content-wrapper bg-border';

                const contentBg = document.createElement('div');
                contentBg.className = 'bg-border';
                
                // Goal title
                const goalTitle = document.createElement('div');
                goalTitle.className = 'goal-title';
                goalTitle.innerHTML = goalData.title;
                contentBg.appendChild(goalTitle);

                // Subtitle
                if (goalData.subtitle) {
                    const subtitle = document.createElement('div');
                    subtitle.className = 'goal-subtitle';
                    subtitle.textContent = goalData.subtitle;
                    contentBg.appendChild(subtitle);
                }

                contentWrapper.appendChild(contentBg);

                // -------------------- Training Split Section --------------------
                if (goalData.trainingSection) {
                    const trainingSectionDiv = document.createElement('div');
                    trainingSectionDiv.className = 'training-section';

                    const trainingTitle = document.createElement('h3');
                    trainingTitle.className = 'section-main-header bg-image';
                    trainingTitle.textContent = goalData.trainingSection.title;
                    trainingSectionDiv.appendChild(trainingTitle);

                    goalData.trainingSection.content.forEach((contentHTML) => {
                        const contentDiv = document.createElement('div');
                        contentDiv.className = 'section-content';
                        contentDiv.innerHTML = contentHTML;
                        trainingSectionDiv.appendChild(contentDiv);
                    });

                    contentWrapper.appendChild(trainingSectionDiv);
                }

                // -------------------- Recovery Priorities Section (for injury recovery) --------------------
                if (goalData.recoverySection) {
                    const recoveryDiv = document.createElement('div');
                    recoveryDiv.className = 'recovery-section';

                    const recoveryTitle = document.createElement('h3');
                    recoveryTitle.className = 'section-main-header recovery-left';
                    recoveryTitle.textContent = goalData.recoverySection.title;
                    recoveryDiv.appendChild(recoveryTitle);

                    const recoveryContent = document.createElement('div');
                    recoveryContent.className = 'section-content';
                    recoveryContent.innerHTML = goalData.recoverySection.content;
                    recoveryDiv.appendChild(recoveryContent);

                    contentWrapper.appendChild(recoveryDiv);
                }

                // -------------------- Nutrition Section --------------------
                if (goalData.nutritionSection) {
                    const nutritionDiv = document.createElement('div');
                    nutritionDiv.className = 'nutrition-section';

                    const nutritionTitle = document.createElement('h3');
                    nutritionTitle.className = 'section-main-header';
                    nutritionTitle.textContent = goalData.nutritionSection.title;
                    nutritionDiv.appendChild(nutritionTitle);

                    const nutritionContent = document.createElement('div');
                    nutritionContent.className = 'section-content';
                    nutritionContent.innerHTML = goalData.nutritionSection.content;
                    nutritionDiv.appendChild(nutritionContent);

                    contentWrapper.appendChild(nutritionDiv);
                }

                // -------------------- Practical Tips Section --------------------
                if (goalData.practicalTipsSection) {
                    const tipsDiv = document.createElement('div');
                    tipsDiv.className = 'practical-tips-section bg-border';

                    const tipsTitle = document.createElement('h3');
                    tipsTitle.className = 'section-main-header';
                    tipsTitle.textContent = goalData.practicalTipsSection.title;
                    tipsDiv.appendChild(tipsTitle);

                    goalData.practicalTipsSection.content.forEach((tip) => {
                        const tipItem = document.createElement('div');
                        tipItem.className = 'tip-item';
                        tipItem.textContent = tip;
                        tipsDiv.appendChild(tipItem);
                    });

                    contentWrapper.appendChild(tipsDiv);
                }

                // -------------------- Supplement Framework Section --------------------
               // -------------------- Supplement Framework Section --------------------
if (goalData.supplementFrameworkSection) {
    const frameworkDiv = document.createElement('div');
    frameworkDiv.className = 'supplement-framework-section bg-border';

    const frameworkTitle = document.createElement('h3');
    frameworkTitle.className = 'section-main-header';
    frameworkTitle.textContent = goalData.supplementFrameworkSection.title;
    frameworkDiv.appendChild(frameworkTitle);

    goalData.supplementFrameworkSection.content.forEach((item) => {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'framework-item';
        itemDiv.style.marginBottom = '16px';
        
        // Handle all supplements with standard format
        if (item.emoji && item.name) {
            const headerDiv = document.createElement('div');
            headerDiv.style.display = 'flex';
            headerDiv.style.alignItems = 'center';
            headerDiv.style.justifyContent = 'space-between';
            headerDiv.style.gap = '12px';
            
            const textContent = document.createElement('div');
            textContent.style.flex = '1';
            
            // Build the content HTML
            let contentHTML = `<strong>${item.emoji} ${item.name}</strong><br>`;
            contentHTML += `<span style="font-size: 0.9em;">${item.dosage}</span><br>`;
            
            // Add purpose only if it exists (for Creatine and BCAA)
            if (item.purpose) {
                contentHTML += `<span style="font-size: 0.85em; color: #666;">Purpose: ${item.purpose}</span>`;
            }
            
            textContent.innerHTML = contentHTML;
            headerDiv.appendChild(textContent);
            
            // Add product image and link (for Creatine and BCAA only)
            if (item.product && !item.typeDetails) {
                const productLink = document.createElement('a');
                productLink.href = item.product.url;
                productLink.target = '_blank';
                productLink.style.display = 'inline-flex';
                productLink.style.flexShrink = '0';
                
                const productImg = document.createElement('img');
                productImg.src = item.product.image;
                productImg.alt = item.product.title;
                productImg.style.width = '50px';
                productImg.style.height = '50px';
                productImg.style.objectFit = 'contain';
                productImg.style.borderRadius = '4px';
                productImg.style.border = '1px solid #e0e0e0';
                
                productLink.appendChild(productImg);
                headerDiv.appendChild(productLink);
            }
            
            itemDiv.appendChild(headerDiv);
            
            // Type Details section for Protein
            if (item.typeDetails) {
                const typeDetailsHeader = document.createElement('div');
                typeDetailsHeader.innerHTML = `<strong>📋 Types:</strong>`;
                typeDetailsHeader.style.marginTop = '12px';
                typeDetailsHeader.style.marginLeft = '16px';
                typeDetailsHeader.style.marginBottom = '8px';
                itemDiv.appendChild(typeDetailsHeader);
                
                item.typeDetails.forEach((detail) => {
                    const detailDiv = document.createElement('div');
                    detailDiv.style.marginLeft = '32px';
                    detailDiv.style.marginBottom = '6px';
                    detailDiv.style.display = 'flex';
                    detailDiv.style.alignItems = 'center';
                    detailDiv.style.justifyContent = 'space-between';
                    detailDiv.style.gap = '12px';
                    
                    const detailText = document.createElement('div');
                    detailText.innerHTML = `<strong>${detail.type}</strong> <span style="font-size: 0.9em; color: #666;">(${detail.description})</span>`;
                    detailText.style.flex = '1';
                    detailDiv.appendChild(detailText);
                    
                    // Add product for this type
                    if (detail.product) {
                        const productLink = document.createElement('a');
                        productLink.href = detail.product.url;
                        productLink.target = '_blank';
                        productLink.style.display = 'inline-flex';
                        productLink.style.flexShrink = '0';
                        productLink.title = detail.product.title;
                        
                        const productImg = document.createElement('img');
                        productImg.src = detail.product.image;
                        productImg.alt = detail.product.title;
                        productImg.style.width = '40px';
                        productImg.style.height = '40px';
                        productImg.style.objectFit = 'contain';
                        productImg.style.borderRadius = '4px';
                        productImg.style.border = '1px solid #e0e0e0';
                        
                        productLink.appendChild(productImg);
                        detailDiv.appendChild(productLink);
                    }
                    
                    itemDiv.appendChild(detailDiv);
                });
            }
        }
        
        frameworkDiv.appendChild(itemDiv);
    });

    contentWrapper.appendChild(frameworkDiv);
}

                // Append contentWrapper to goalSection
                goalSection.appendChild(contentWrapper);

                // -------------------- Supplement Timing Table --------------------
                if (goalData.supplementTiming) {
                    const tableSection = document.createElement('div');
                    tableSection.className = 'table-section bg-border';

                    const tableTitle = document.createElement('div');
                    tableTitle.className = 'section-header';
                    tableTitle.textContent = goalData.supplementTiming.title;
                    tableSection.appendChild(tableTitle);

                    const table = document.createElement('table');
                    table.className = 'supplement-table bg-border';

                    // Create header row
                    const thead = document.createElement('thead');
                    const headerRow = document.createElement('tr');
                    goalData.supplementTiming.headers.forEach((header) => {
                        const th = document.createElement('th');
                        th.textContent = header;
                        headerRow.appendChild(th);
                    });
                    thead.appendChild(headerRow);
                    table.appendChild(thead);

                    // Create data rows
                    const tbody = document.createElement('tbody');
                    goalData.supplementTiming.data.forEach((row) => {
                        const tr = document.createElement('tr');
                        row.forEach((cell, cellIndex) => {
                            const td = document.createElement('td');
                            
                            // Check if this is the first cell and it contains product data (array)
                            if (cellIndex === 0 && Array.isArray(cell)) {
                                // This is the products array in the first column
                                cell.forEach(product => {
                                    const container = document.createElement('div');
                                    container.style.display = 'flex';
                                    container.style.alignItems = 'center';
                                    container.style.justifyContent = 'center';
                                    container.style.gap = '8px';

                                    // Product image with link
                                    if (product.image && product.url) {
                                        const imgLink = document.createElement('a');
                                        imgLink.href = product.url;
                                        imgLink.target = '_blank';
                                        imgLink.style.display = 'inline-flex';

                                        const img = document.createElement('img');
                                        img.src = product.image;
                                        img.alt = product.title || '';
                                        img.style.width = '40px';
                                        img.style.height = '40px';
                                        img.style.objectFit = 'contain';
                                        img.style.borderRadius = '4px';
                                        imgLink.appendChild(img);
                                        container.appendChild(imgLink);
                                    }

                                    td.appendChild(container);
                                });
                            } else {
                                // Regular text content
                                td.textContent = cell;
                            }
                            tr.appendChild(td);
                        });
                        tbody.appendChild(tr);
                    });
                    table.appendChild(tbody);

                    tableSection.appendChild(table);
                    goalSection.appendChild(tableSection);
                }

                list.appendChild(goalSection);
            }
        });
    }
}*/

/*function displayRecommendations(goals, recommendations) {
    const list = document.getElementById('recommendations-list');
    if (list) {
        list.innerHTML = '';

        goals.forEach((goal, index) => {
            if (recommendations[goal]) {
                const goalData = recommendations[goal];

                // Create goal section container
                const goalSection = document.createElement('div');
                goalSection.className = 'goal-section';

                // Create wrapper div for all content
                const contentWrapper = document.createElement('div');
                contentWrapper.className = 'content-wrapper bg-border';

                const contentBg = document.createElement('div');
                contentBg.className = 'bg-border';
                
                // Goal title
                const goalTitle = document.createElement('div');
                goalTitle.className = 'goal-title';
                goalTitle.innerHTML = goalData.title;
                contentBg.appendChild(goalTitle);

                // Subtitle
                if (goalData.subtitle) {
                    const subtitle = document.createElement('div');
                    subtitle.className = 'goal-subtitle';
                    subtitle.textContent = goalData.subtitle;
                    contentBg.appendChild(subtitle);
                }

                contentWrapper.appendChild(contentBg);

                // -------------------- Training Split Section --------------------
                if (goalData.trainingSection) {
                    const trainingSectionDiv = document.createElement('div');
                    trainingSectionDiv.className = 'training-section';

                    const trainingTitle = document.createElement('h3');
                    trainingTitle.className = 'section-main-header';
                    trainingTitle.textContent = goalData.trainingSection.title;
                    trainingSectionDiv.appendChild(trainingTitle);

                    goalData.trainingSection.content.forEach((contentHTML) => {
                        const contentDiv = document.createElement('div');
                        contentDiv.className = 'section-content';
                        contentDiv.innerHTML = contentHTML;
                        trainingSectionDiv.appendChild(contentDiv);
                    });

                    contentWrapper.appendChild(trainingSectionDiv);
                }

                // -------------------- Nutrition Section --------------------
                if (goalData.nutritionSection) {
                    const nutritionDiv = document.createElement('div');
                    nutritionDiv.className = 'nutrition-section';

                    const nutritionTitle = document.createElement('h3');
                    nutritionTitle.className = 'section-main-header';
                    nutritionTitle.textContent = goalData.nutritionSection.title;
                    nutritionDiv.appendChild(nutritionTitle);

                    const nutritionContent = document.createElement('div');
                    nutritionContent.className = 'section-content';
                    nutritionContent.innerHTML = goalData.nutritionSection.content;
                    nutritionDiv.appendChild(nutritionContent);

                    contentWrapper.appendChild(nutritionDiv);
                }

                // -------------------- Practical Tips Section --------------------
                if (goalData.practicalTipsSection) {
                    const tipsDiv = document.createElement('div');
                    tipsDiv.className = 'practical-tips-section bg-border';

                    const tipsTitle = document.createElement('h3');
                    tipsTitle.className = 'section-main-header';
                    tipsTitle.textContent = goalData.practicalTipsSection.title;
                    tipsDiv.appendChild(tipsTitle);

                    goalData.practicalTipsSection.content.forEach((tip) => {
                        const tipItem = document.createElement('div');
                        tipItem.className = 'tip-item';
                        tipItem.textContent = tip;
                        tipsDiv.appendChild(tipItem);
                    });

                    contentWrapper.appendChild(tipsDiv);
                }

                // -------------------- Supplement Framework Section --------------------
           // -------------------- Supplement Framework Section --------------------
if (goalData.supplementFrameworkSection) {
    const frameworkDiv = document.createElement('div');
    frameworkDiv.className = 'supplement-framework-section bg-border';

    const frameworkTitle = document.createElement('h3');
    frameworkTitle.className = 'section-main-header';
    frameworkTitle.textContent = goalData.supplementFrameworkSection.title;
    frameworkDiv.appendChild(frameworkTitle);

    goalData.supplementFrameworkSection.content.forEach((item) => {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'framework-item';
        itemDiv.style.marginBottom = '16px';
        
        // Handle Creatine and BCAA (simple supplements with single product)
        if (item.emoji && item.name && (item.name === 'Creatine' || item.name === 'BCAA + Electrolytes')) {
            const headerDiv = document.createElement('div');
            headerDiv.style.display = 'flex';
            headerDiv.style.alignItems = 'center';
            headerDiv.style.justifyContent = 'space-between';
            headerDiv.style.gap = '12px';
            
            const textContent = document.createElement('div');
            textContent.style.flex = '1';
            textContent.innerHTML = `
                <strong>${item.emoji} ${item.name}</strong><br>
                <span style="font-size: 0.9em;">${item.dosage}</span><br>
                <span style="font-size: 0.85em; color: #666;">Purpose: ${item.purpose}</span>
            `;
            headerDiv.appendChild(textContent);
            
            // Add product image and link
            if (item.product) {
                const productLink = document.createElement('a');
                productLink.href = item.product.url;
                productLink.target = '_blank';
                productLink.style.display = 'inline-flex';
                productLink.style.flexShrink = '0';
                
                const productImg = document.createElement('img');
                productImg.src = item.product.image;
                productImg.alt = item.product.title;
                productImg.style.width = '50px';
                productImg.style.height = '50px';
                productImg.style.objectFit = 'contain';
                productImg.style.borderRadius = '4px';
                productImg.style.border = '1px solid #e0e0e0';
                
                productLink.appendChild(productImg);
                headerDiv.appendChild(productLink);
            }
            
            itemDiv.appendChild(headerDiv);
        }
        // Handle Protein (complex with timings and typeDetails)
        else if (item.emoji && item.name === 'Protein') {
            const proteinHeader = document.createElement('div');
            proteinHeader.innerHTML = `<strong>${item.emoji} ${item.name}</strong>`;
            proteinHeader.style.marginBottom = '12px';
            itemDiv.appendChild(proteinHeader);
            
            // Timings section - more compact
            if (item.timings) {
                item.timings.forEach((timing) => {
                    const timingDiv = document.createElement('div');
                    timingDiv.style.marginLeft = '16px';
                    timingDiv.style.marginBottom = '10px';
                    timingDiv.style.padding = '8px';
                    timingDiv.style.backgroundColor = '#f9f9f9';
                    timingDiv.style.borderRadius = '6px';
                    timingDiv.style.display = 'flex';
                    timingDiv.style.alignItems = 'center';
                    timingDiv.style.gap = '12px';
                    
                    const textSection = document.createElement('div');
                    textSection.style.flex = '1';
                    textSection.innerHTML = `
                        <strong>⏰ ${timing.time}</strong> <span style="font-size: 0.9em;">(${timing.amount})</span><br>
                        <span style="font-size: 0.85em; color: #555;">Types: ${timing.types}</span><br>
                        <span style="font-size: 0.85em; color: #666;">Purpose: ${timing.purpose}</span>
                    `;
                    timingDiv.appendChild(textSection);
                    
                    // Add products for this timing - horizontal compact layout
                    if (timing.products && timing.products.length > 0) {
                        const productsContainer = document.createElement('div');
                        productsContainer.style.display = 'flex';
                        productsContainer.style.gap = '6px';
                        productsContainer.style.flexShrink = '0';
                        
                        timing.products.forEach((product) => {
                            const productLink = document.createElement('a');
                            productLink.href = product.url;
                            productLink.target = '_blank';
                            productLink.style.display = 'inline-flex';
                            productLink.title = product.title;
                            
                            const productImg = document.createElement('img');
                            productImg.src = product.image;
                            productImg.alt = product.title;
                            productImg.style.width = '45px';
                            productImg.style.height = '45px';
                            productImg.style.objectFit = 'contain';
                            productImg.style.borderRadius = '6px';
                            productImg.style.border = '1px solid #e0e0e0';
                            
                            productLink.appendChild(productImg);
                            productsContainer.appendChild(productLink);
                        });
                        
                        timingDiv.appendChild(productsContainer);
                    }
                    
                    itemDiv.appendChild(timingDiv);
                });
            }
            
            // Type Details section - compact horizontal layout
            if (item.typeDetails) {
                const typeDetailsHeader = document.createElement('div');
                typeDetailsHeader.innerHTML = `<strong>📋 Types:</strong>`;
                typeDetailsHeader.style.marginTop = '12px';
                typeDetailsHeader.style.marginLeft = '16px';
                typeDetailsHeader.style.marginBottom = '8px';
                itemDiv.appendChild(typeDetailsHeader);
                
                item.typeDetails.forEach((detail) => {
                    const detailDiv = document.createElement('div');
                    detailDiv.style.marginLeft = '32px';
                    detailDiv.style.marginBottom = '6px';
                    detailDiv.style.display = 'flex';
                    detailDiv.style.alignItems = 'center';
                    detailDiv.style.justifyContent = 'space-between';
                    detailDiv.style.gap = '12px';
                    
                    const detailText = document.createElement('div');
                    detailText.innerHTML = `<strong>${detail.type}</strong> <span style="font-size: 0.9em; color: #666;">(${detail.description})</span>`;
                    detailText.style.flex = '1';
                    detailDiv.appendChild(detailText);
                    
                    // Add product for this type
                    if (detail.product) {
                        const productLink = document.createElement('a');
                        productLink.href = detail.product.url;
                        productLink.target = '_blank';
                        productLink.style.display = 'inline-flex';
                        productLink.style.flexShrink = '0';
                        productLink.title = detail.product.title;
                        
                        const productImg = document.createElement('img');
                        productImg.src = detail.product.image;
                        productImg.alt = detail.product.title;
                        productImg.style.width = '40px';
                        productImg.style.height = '40px';
                        productImg.style.objectFit = 'contain';
                        productImg.style.borderRadius = '4px';
                        productImg.style.border = '1px solid #e0e0e0';
                        
                        productLink.appendChild(productImg);
                        detailDiv.appendChild(productLink);
                    }
                    
                    itemDiv.appendChild(detailDiv);
                });
            }
        }
        
        frameworkDiv.appendChild(itemDiv);
    });

    contentWrapper.appendChild(frameworkDiv);
}

                // Append contentWrapper to goalSection
                goalSection.appendChild(contentWrapper);

                // -------------------- Supplement Timing Table --------------------
                if (goalData.supplementTiming) {
                    const tableSection = document.createElement('div');
                    tableSection.className = 'table-section bg-border';

                    const tableTitle = document.createElement('div');
                    tableTitle.className = 'section-header';
                    tableTitle.textContent = goalData.supplementTiming.title;
                    tableSection.appendChild(tableTitle);

                    const table = document.createElement('table');
                    table.className = 'supplement-table bg-border';

                    // Create header row
                    const thead = document.createElement('thead');
                    const headerRow = document.createElement('tr');
                    goalData.supplementTiming.headers.forEach((header) => {
                        const th = document.createElement('th');
                        th.textContent = header;
                        headerRow.appendChild(th);
                    });
                    thead.appendChild(headerRow);
                    table.appendChild(thead);

                    // Create data rows
                    const tbody = document.createElement('tbody');
                    goalData.supplementTiming.data.forEach((row) => {
                        const tr = document.createElement('tr');
                        row.forEach((cell, cellIndex) => {
                            const td = document.createElement('td');
                            
                            // Check if this is the first cell and it contains product data (array)
                            if (cellIndex === 0 && Array.isArray(cell)) {
                                // This is the products array in the first column
                                cell.forEach(product => {
                                    const container = document.createElement('div');
                                    container.style.display = 'flex';
                                    container.style.alignItems = 'center';
                                    container.style.justifyContent = 'center';
                                    container.style.gap = '8px';

                                    // Product image with link
                                    if (product.image && product.url) {
                                        const imgLink = document.createElement('a');
                                        imgLink.href = product.url;
                                        imgLink.target = '_blank';
                                        imgLink.style.display = 'inline-flex';

                                        const img = document.createElement('img');
                                        img.src = product.image;
                                        img.alt = product.title || '';
                                        img.style.width = '40px';
                                        img.style.height = '40px';
                                        img.style.objectFit = 'contain';
                                        img.style.borderRadius = '4px';
                                        imgLink.appendChild(img);
                                        container.appendChild(imgLink);
                                    }

                                    td.appendChild(container);
                                });
                            } else {
                                // Regular text content
                                td.textContent = cell;
                            }
                            tr.appendChild(td);
                        });
                        tbody.appendChild(tr);
                    });
                    table.appendChild(tbody);

                    tableSection.appendChild(table);
                    goalSection.appendChild(tableSection);
                }

                list.appendChild(goalSection);
            }
        });
    }
}*/

/*function displayRecommendations(goals, recommendations) {
    const list = document.getElementById('recommendations-list');
    if (list) {
        list.innerHTML = '';

        goals.forEach((goal, index) => {
            if (recommendations[goal]) {
                const goalData = recommendations[goal];

                // Create goal section container
                const goalSection = document.createElement('div');
                goalSection.className = 'goal-section';

                // Create wrapper div for all content
                const contentWrapper = document.createElement('div');
                contentWrapper.className = 'content-wrapper bg-border';
                const recommendationsHeading = document.createElement('h3');
                recommendationsHeading.textContent = 'Key Recommendations:';
                contentWrapper.appendChild(recommendationsHeading);


                const contentBg = document.createElement('div');
                contentBg.className = 'bg-border';
                
                
                // Goal title
                const goalTitle = document.createElement('div');
                goalTitle.className = 'goal-title';
                goalTitle.innerHTML = goalData.title;
                contentBg.appendChild(goalTitle);

                // Subtitle
                if (goalData.subtitle) {
                    const subtitle = document.createElement('div');
                    subtitle.className = 'goal-subtitle';
                    subtitle.textContent = goalData.subtitle;
                    contentBg.appendChild(subtitle);
                }

                // Finally append the bg container to the wrapper
                contentWrapper.appendChild(contentBg);


                
                // Main recommendations
                if (goalData.recommendations && goalData.recommendations.length > 0) {
                    goalData.recommendations.forEach((rec) => {
                        const recDiv = document.createElement('div');
                        recDiv.className = 'section-content';

                        // Split by the first colon to separate icon+title from content
                        const colonIndex = rec.indexOf(':');
                        if (colonIndex > -1) {
                            const title = rec.substring(0, colonIndex + 1);
                            const content = rec.substring(colonIndex + 1);

                            const titleSpan = document.createElement('div');
                            titleSpan.className = 'section-header';
                            titleSpan.innerHTML = title;
                            recDiv.appendChild(titleSpan);

                            // Split content by bullet points and create separate divs
                            const bulletPoints = content
                                .split('•')
                                .map((point) => point.trim())
                                .filter((point) => point.length > 0);

                            bulletPoints.forEach((point) => {
                           
                                const pointDiv = document.createElement('div');
                                pointDiv.className = 'detail-text';
                                pointDiv.innerHTML = `${point}`;
                                recDiv.appendChild(pointDiv);
                            });
                        } else {
                            recDiv.className = 'detail-text bg-border';
                            recDiv.textContent = rec;
                        }

                        // Append to wrapper
                        contentWrapper.appendChild(recDiv);
                    });
                }

                // Append contentWrapper to goalSection
                goalSection.appendChild(contentWrapper);

                // Supplement Timing Table
                if (goalData.supplementTiming) {
                    const tableSection = document.createElement('div');
                    tableSection.className = 'table-section bg-border';

                    const tableTitle = document.createElement('div');
                    tableTitle.className = 'section-header';
                    tableTitle.textContent = goalData.supplementTiming.title;
                    tableSection.appendChild(tableTitle);

                    const table = document.createElement('table');
                    table.className = 'supplement-table bg-border';

                    // Create header row
                    const thead = document.createElement('thead');
                    const headerRow = document.createElement('tr');
                    goalData.supplementTiming.headers.forEach((header) => {
                        const th = document.createElement('th');
                        th.textContent = header;
                        headerRow.appendChild(th);
                    });
                    thead.appendChild(headerRow);
                    table.appendChild(thead);

                    // Create data rows
                    const tbody = document.createElement('tbody');
                    goalData.supplementTiming.data.forEach((row) => {
                        const tr = document.createElement('tr');
                        row.forEach((cell, cellIndex) => {
                            const td = document.createElement('td');
                            
                            // Check if this is the first cell and it contains product data (array)
                            if (cellIndex === 0 && Array.isArray(cell)) {
                                // This is the products array in the first column
                                cell.forEach(product => {
                                    const container = document.createElement('div');
                                    container.style.display = 'flex';
                                    container.style.alignItems = 'center';
                                    container.style.justifyContent = 'center';
                                    container.style.gap = '8px';

                                    // Product image with link
                                    if (product.image && product.url) {
                                        const imgLink = document.createElement('a');
                                        imgLink.href = product.url;
                                        imgLink.target = '_blank';
                                        imgLink.style.display = 'inline-flex';

                                        const img = document.createElement('img');
                                        img.src = product.image;
                                        img.alt = product.title || '';
                                        img.style.width = '40px';
                                        img.style.height = '40px';
                                        img.style.objectFit = 'contain';
                                        img.style.borderRadius = '4px';
                                        imgLink.appendChild(img);
                                        container.appendChild(imgLink);
                                    }

                                    td.appendChild(container);
                                });
                            } else {
                                // Regular text content
                                td.textContent = cell;
                            }
                            tr.appendChild(td);
                        });
                        tbody.appendChild(tr);
                    });
                    table.appendChild(tbody);

                    tableSection.appendChild(table);
                    goalSection.appendChild(tableSection);
                }
            const combinedSection = document.createElement('div');
            combinedSection.className = 'supplement-practical-tips';


            // -------------------- Supplement Notes --------------------
            if (goalData.supplementNotes && goalData.supplementNotes.length > 0) {
                const notesSection = document.createElement('div');
                notesSection.className = 'supplement-notes';

                goalData.supplementNotes.forEach((note, noteIndex) => {
                    if (noteIndex === 0) {
                        // Title
                        const notesTitle = document.createElement('div');
                        notesTitle.className = 'section-header bg-border';
                        notesTitle.textContent = note;
                        notesSection.appendChild(notesTitle);

                    } else if (note.includes('🧠 Leucine Threshold')) {
                        // Special styling
                        const leucineDiv = document.createElement('div');
                        leucineDiv.className = 'leucine-note bg-border';
                        leucineDiv.textContent = note;
                        notesSection.appendChild(leucineDiv);

                    } else {
                        // Regular note
                        const noteDiv = document.createElement('div');
                        noteDiv.className = 'supplement-note bg-border';

                        const colonIndex = note.indexOf(':');
                        if (colonIndex > -1) {
                            const supplementName = note.substring(0, colonIndex);
                            const description = note.substring(colonIndex);
                            noteDiv.innerHTML = `<strong>${supplementName}</strong>${description}`;
                        } else {
                            noteDiv.textContent = note;
                        }

                        notesSection.appendChild(noteDiv);
                    }
                });

                // Append to combined wrapper
                combinedSection.appendChild(notesSection);
            }


            // -------------------- Practical Tips --------------------
            if (goalData.practicalTips && goalData.practicalTips.length > 0) {
                const tipsSection = document.createElement('div');
                tipsSection.className = 'practical-tips bg-border';

                goalData.practicalTips.forEach((tip, tipIndex) => {
                    if (tipIndex === 0) {
                        const tipsTitle = document.createElement('div');
                        tipsTitle.className = 'section-header';
                        tipsTitle.textContent = tip;
                        tipsSection.appendChild(tipsTitle);

                    } else {
                        const tipDiv = document.createElement('div');
                        tipDiv.className = 'tip-item';
                        tipDiv.textContent = tip;
                        tipsSection.appendChild(tipDiv);
                    }
                });

                // Append to combined wrapper
                combinedSection.appendChild(tipsSection);
            }


            // ✔ Append combined section ONCE
            goalSection.appendChild(combinedSection);

            

               const combinedSource = document.createElement('div');
                combinedSource.className = 'combined-source-wrapper';


                // -------------------- keyScience section --------------------
                if (goalData.keyScience && goalData.keyScience.length > 0) {
                    const keyScienceSection = document.createElement('div');
                    keyScienceSection.className = 'keyScience-tips bg-border';

                    goalData.keyScience.forEach((tip, index) => {
                        if (index === 0) {
                            const title = document.createElement('div');
                            title.className = 'section-header';
                            title.textContent = tip;
                            keyScienceSection.appendChild(title);
                        } else {
                            const item = document.createElement('div');
                            item.className = 'tip-item';
                            item.textContent = tip;
                            keyScienceSection.appendChild(item);
                        }
                    });

                    combinedSource.appendChild(keyScienceSection);
                }


                // -------------------- sources section --------------------
                if (goalData.sources && goalData.sources.length > 0) {
                    const sourcesSection = document.createElement('div');
                    sourcesSection.className = 'sources bg-border';

                    const title = document.createElement('div');
                    title.className = 'section-header';
                    title.textContent = 'Sources:';
                    sourcesSection.appendChild(title);

                    const list = document.createElement('ul');
                    goalData.sources.forEach(source => {
                        const li = document.createElement('li');
                        li.textContent = source;
                        list.appendChild(li);
                    });

                    sourcesSection.appendChild(list);
                    combinedSource.appendChild(sourcesSection);
                }


                // -------------------- append combinedSource to goalSection --------------------
                goalSection.appendChild(combinedSource);

         
                list.appendChild(goalSection);
                if (goalData.disclaimer) {
                    const disclaimerSection = document.createElement('div');
                    disclaimerSection.className = 'disclaimer bg-border';
                    
                    const disclaimerTitle = document.createElement('div');
                    disclaimerTitle.className = 'section-header';
                    disclaimerTitle.textContent = '⚠️ Disclaimer';
                    disclaimerSection.appendChild(disclaimerTitle);
                    
                    const disclaimerText = document.createElement('div');
                    disclaimerText.className = 'disclaimer-text';
                    disclaimerText.textContent = goalData.disclaimer;
                    disclaimerSection.appendChild(disclaimerText);
                    
                    goalSection.appendChild(disclaimerSection);
                }
            }
        });
    }
}
*/
// ENHANCED: updateSummary with complete data collection
/* function updateSummary() {
   const name = document.getElementById('user-name').value;
   const email = document.getElementById('user-email').value;
   const age = getValue('age');
   const gender = getRadioValue('biological-gender');
     const weight = convertWeightToKg();
   const bodyFat = getValue('custom-body-fat');
   const activityLevel = getRadioValue('activity-level');
   const selectedGoals = getSelectedGoals();

   // Update summary displays (existing functionality)
   document.getElementById('summary-name').textContent = name || '-';
   document.getElementById('summary-email').textContent = email || '-';
   document.getElementById('summary-age').textContent = age || '-';
   document.getElementById('summary-gender').textContent = gender ? (gender === 'male' ? 'Male' : 'Female') : '-';
   document.getElementById('summary-height').textContent = getHeightDisplay();
   document.getElementById('summary-weight').textContent = weight || '-';
   document.getElementById('summary-bmi').textContent = userData.bmi ? userData.bmi.toFixed(1) : '-';
   document.getElementById('summary-bmi-category').textContent = userData.bmiCategory || '-';
   document.getElementById('summary-body-fat').textContent = bodyFat || '-';
   document.getElementById('summary-lean-mass').textContent = userData.lbm ? userData.lbm.toFixed(1) : '-';

   // Activity level display
   const activityLabels = {
     sedentary: 'Sedentary',
     lightly_active: 'Lightly Active',
     moderately_active: 'Moderately Active',
     very_active: 'Very Active',
     extremely_active: 'Extremely Active',
   };
   document.getElementById('summary-activity').textContent = activityLabels[activityLevel] || '-';

   // Goals display
   const goalNames = selectedGoals.map((goal) => FITNESS_GOALS[goal]?.name || goal).join(', ');
   document.getElementById('summary-goals').textContent = goalNames || '-';

   // Metabolic summary
   document.getElementById('summary-tdee').textContent = userData.tdee ? Math.round(userData.tdee) : '-';
   document.getElementById('summary-rmr').textContent = userData.rmr ? Math.round(userData.rmr) : '-';
   document.getElementById('summary-neat').textContent = userData.neat ? Math.round(userData.neat) : '-';
   document.getElementById('summary-eat').textContent = userData.eat ? Math.round(userData.eat) : '-';
   document.getElementById('summary-tef').textContent = userData.tef ? Math.round(userData.tef) : '-';

   // NEW: Store all form data in userData object (doesn't affect existing functionality)
   userData.name = name;
   userData.email = email;
   userData.age = age;
   userData.gender = gender;
  
   userData.weight = convertWeightToKg();
   userData.height = convertHeightToCm();
   userData.heightDisplay = getHeightDisplay();
   userData.heightUnit = getRadioValue('height-unit');
   userData.bodyFat = bodyFat;
   userData.activityLevel = activityLevel;

   // Exercise data
   userData.exerciseData = {};
   userData.dontExercise = document.getElementById('dont-exercise')?.checked || false;
   Object.keys(EXERCISE_MET).forEach((intensity) => {
     const minutesId = intensity.replace('_', '-') + '-minutes';
     userData.exerciseData[intensity] = getValue(minutesId);
   });

   // NEW: Update global data object
   window.userCalculatorData = collectAllUserData();

   //console.log('Complete user data:', userData);
 }*/
function updateSummary() {
    const name = document.getElementById('user-name').value;
    const email = document.getElementById('user-email').value;
    const age = getValue('age');
    const gender = getRadioValue('biological-gender');
    const weightKg = convertWeightToKg();
    const heightCm = convertHeightToCm();
    const bodyFat = getValue('custom-body-fat');
    const activityLevel = getRadioValue('activity-level');
    const selectedGoals = getSelectedGoals();
  
    const waistCm = convertWaistToCm();
    const hipCm = convertHipToCm();

    // Update summary displays
    document.getElementById('summary-name').textContent = name || '-';
    document.getElementById('summary-email').textContent = email || '-';
    document.getElementById('summary-age').textContent = age || '-';
    document.getElementById('summary-gender').textContent = gender ? (gender === 'male' ? 'Male' : 'Female') : '-';

    // Fixed: Always show numeric values with units
    document.getElementById('summary-height').textContent = heightCm ? `${heightCm.toFixed(1)} cm` : '-';
    document.getElementById('summary-weight').textContent = weightKg ? `${weightKg.toFixed(1)} kg` : '-';

    //document.getElementById('summary-bmi').textContent = userData.bmi ? userData.bmi.toFixed(1) : '-';
    const bmiEl = document.getElementById('summary-bmi');
  const textGreenEl = document.querySelector('.text-green1');
    if (bmiEl) {
    bmiEl.textContent = userData.bmi ? userData.bmi.toFixed(1) : '-';
    
    /*if (userData.bmi && userData.bmi < 18.5) {
        textGreenEl.classList.add('bmi-low');
    }*/
    textGreenEl.classList.remove(
        'bmi-underweight',
        'bmi-normal',
        'bmi-overweight',
        'bmi-obese',
         'bmi-low'
    );
     if (userData.bmi && userData.bmi < 18.5) {
        textGreenEl.classList.add('bmi-low');
    } else if (userData.bmi && userData.bmi < 25) {
        textGreenEl.classList.add('bmi-normal');
    } else if (userData.bmi && userData.bmi < 30) {
        textGreenEl.classList.add('bmi-overweight');
    } else if (userData.bmi) {
        textGreenEl.classList.add('bmi-obese');
    }
    }
    document.getElementById('summary-bmi-category').textContent = userData.bmiCategory || '-';
  
    document.getElementById('summary-body-fat').textContent = bodyFat ? `${bodyFat}` : '-';
    document.getElementById('summary-lean-mass').textContent = userData.lbm ? `${userData.lbm.toFixed(1)}` : '-';

    // Activity level display
    const activityLabels = {
        sedentary: 'Sedentary',
        lightly_active: 'Lightly Active',
        moderately_active: 'Moderately Active',
        very_active: 'Very Active',
        extremely_active: 'Extremely Active',
    };
    document.getElementById('summary-activity').textContent = activityLabels[activityLevel] || '-';

    // Goals display
    const goalNames = selectedGoals.map((goal) => FITNESS_GOALS[goal]?.name || goal).join(', ');
    document.getElementById('summary-goals').textContent = goalNames || '-';

   document.querySelector('.lifestyle-ac').textContent = activityLabels[activityLevel] || '-';
    // Metabolic summary
    document.getElementById('summary-tdee').textContent = userData.tdee ? Math.round(userData.tdee) : '-';
    document.getElementById('summary-rmr').textContent = userData.rmr ? Math.round(userData.rmr) : '-';
    document.getElementById('summary-neat').textContent = userData.neat ? Math.round(userData.neat) : '-';
    document.getElementById('summary-eat').textContent = userData.eat ? Math.round(userData.eat) : '-';
    document.getElementById('summary-tef').textContent = userData.tef ? Math.round(userData.tef) : '-';

    // Store all form data - using CONVERTED values
    userData.name = name;
    userData.email = email;
    userData.age = age;
    userData.gender = gender;
    userData.weight = weightKg;  // Store converted kg value
    userData.height = heightCm;  // Store converted cm value
    userData.heightDisplay = getHeightDisplay();  // Keep formatted display separately
    userData.heightUnit = getRadioValue('height-unit');
    userData.bodyFat = bodyFat;
    userData.activityLevel = activityLevel;
    userData.waist = waistCm;  // Store converted cm value
    userData.hip = hipCm;      // Store converted cm value

    // Exercise data
    userData.exerciseData = {};
    userData.dontExercise = document.getElementById('dont-exercise')?.checked || false;
    Object.keys(EXERCISE_MET).forEach((intensity) => {
        const minutesId = intensity.replace('_', '-') + '-minutes';
        userData.exerciseData[intensity] = getValue(minutesId);
    });


    window.userCalculatorData = collectAllUserData();
}
// ENHANCED: recalculateAll with data updates
function recalculateAll() {
    calculateBMI();
    calculateLBM();
    calculateRMR();
    calculateNEAT();
    calculateEAT();
    calculateTEF();
    calculateTDEE();
    calculateBMR();
    if (getSelectedGoals().length > 0) {
        calculateNutritionForMultipleGoals();
    }
    updateSummary();

    // NEW: Keep userData always updated (doesn't affect existing functionality)
    window.userCalculatorData = collectAllUserData();
    let checkbox = document.getElementById('dont-exercise');
    let Yescheckbox = document.getElementById('structured-exercise-yes');
    let textBlock = document.querySelector('.noexercisetext');
    let textYesBlock = document.querySelector('.yesexercisetext');
    if (checkbox) {
        if (checkbox.checked) {
            if (textBlock) textBlock.style.display = 'block';
        } else {
            if (textBlock) textBlock.style.display = 'none';
        }
    }
    if (Yescheckbox) {
        if (Yescheckbox.checked) {
            if (textYesBlock) textYesBlock.style.display = 'block';
        } else {
            if (textYesBlock) textYesBlock.style.display = 'none';
        }
    }
}

// Height unit switching
/*function switchHeightUnits() {
  const unit = getRadioValue('height-unit');
  
  // Hide all height input groups
  document.getElementById('height-cm-group').style.display = 'none';
  document.getElementById('height-feet-group').style.display = 'none';
  document.getElementById('height-inches-group').style.display = 'none';
  
  // Show appropriate input group
  if (unit === 'cm') {
      document.getElementById('height-cm-group').style.display = 'block';
  } else if (unit === 'feet-inches') {
      document.getElementById('height-feet-group').style.display = 'block';
  } else if (unit === 'inches') {
      document.getElementById('height-inches-group').style.display = 'block';
  }
  
  recalculateAll();
}*/
function switchHeightUnits() {
    const unit = getRadioValue('height-unit');

    // Hide all height input groups
    document.getElementById('height-cm-group').style.display = 'none';
    document.getElementById('height-feet-group').style.display = 'none';
    document.getElementById('height-inches-group').style.display = 'none';

    // Hide all waist and hip input groups
    document.getElementById('waist-cm-group').style.display = 'none';
    document.getElementById('waist-inches-group').style.display = 'none';
    document.getElementById('hip-cm-group').style.display = 'none';
    document.getElementById('hip-inches-group').style.display = 'none';

    // Show appropriate input groups based on height unit
    if (unit === 'cm') {
        document.getElementById('height-cm-group').style.display = 'block';
        document.getElementById('waist-cm-group').style.display = 'block';
        document.getElementById('hip-cm-group').style.display = 'block';
    } else if (unit === 'feet-inches') {
        document.getElementById('height-feet-group').style.display = 'block';
        document.getElementById('waist-inches-group').style.display = 'block';
        document.getElementById('hip-inches-group').style.display = 'block';
    } else if (unit === 'inches') {
        document.getElementById('height-inches-group').style.display = 'block';
        document.getElementById('waist-inches-group').style.display = 'block';
        document.getElementById('hip-inches-group').style.display = 'block';
    }

    recalculateAll();
}
// Reset calculator
function resetCalculator() {
    if (confirm('Are you sure you want to start over? All data will be lost.')) {
        // Clear all inputs
        document.querySelectorAll('input').forEach((input) => {
            if (input.type === 'radio' || input.type === 'checkbox') {
                input.checked = false;
            } else {
                input.value = '';
            }
        });

        // Reset height unit to cm
        // document.getElementById('unit-cm').checked = true;
       // switchHeightUnits();

        // Reset variables
        currentStep = 1;
        skipExercise = false;
        userData = {};

        // NEW: Clear global data
        window.userCalculatorData = {};

        // Clear displays
        document.querySelectorAll('[id$="-display"]').forEach((el) => {
            if (el) {
                el.textContent = '0';
            }
        });

        // Reset BMI category to '-'
        const bmiCategory = document.getElementById('bmi-category');
        if (bmiCategory) {
            bmiCategory.textContent = '-';
        }

        // Reset feedback text to '-'
        const feedbackText = document.querySelector('.feedback-text');
        if (feedbackText) {
            feedbackText.textContent = '-';
        }

        // Clear form validation classes
        document.querySelectorAll('.form-group').forEach((group) => {
            group.classList.remove('error', 'valid');
        });
        document.querySelectorAll('.radio-option').forEach((option) => {
            option.classList.remove('selected');
        });

        // Return to step 1
        showStep(1);
    }
}

// Validation functions
function validateStep(step) {
    const currentPanel = document.querySelector(`.step-panel[data-step="${step}"]`);

    // Clear previous errors
    currentPanel.querySelectorAll('.form-group, .radio-grid').forEach((group) => {
        group.classList.remove('error');
    });

    let isValid = true;

    switch (step) {
        case 1: // Name & Email
            const nameInput = document.getElementById('user-name');
            const emailInput = document.getElementById('user-email');

            if (!nameInput.value.trim()) {
                showError(currentPanel, 'user-name', 'Please enter your name');
                isValid = false;
            }

            if (!emailInput.value.trim() || !validateEmail(emailInput.value)) {
                showError(currentPanel, 'user-email', 'Please enter a valid email address');
                isValid = false;
            }
            break;



        case 2: // Gender + Age + Weight + Height + Waist + Hip (Combined)
            // Gender
            if (!getRadioValue('biological-gender')) {
                showError(currentPanel, 'biological-gender', 'Please select your biological gender', true);
                isValid = false;
            }

            // Age
            const age = getValue('age');
            if (!age || age < 18 || age > 100) {
                showError(currentPanel, 'age', 'Please enter a valid age (18-100)');
                isValid = false;
            }

            // Unit System Check
            const unitSystem = getRadioValue('unit-system');

            // Weight Validation
            let weightValid = false;
            let weightErrorField = null;
            let weightErrorMessage = '';

            if (unitSystem === 'imperial') {
                const weightLbs = getValue('weight-lbs');
                weightValid = weightLbs >= 66 && weightLbs <= 1600;
                weightErrorField = 'weight-lbs';
                weightErrorMessage = 'Please enter a valid weight (66-1600 lbs)';
            } else {
                const weight = getValue('weight');
                weightValid = weight >= 30 && weight <= 650;
                weightErrorField = 'weight';
                weightErrorMessage = 'Please enter a valid weight (30-650 kg)';
            }

            if (!weightValid) {
                showError(currentPanel, weightErrorField, weightErrorMessage);
                isValid = false;
            }

            // Height Validation
            let heightValid = false;
            let heightErrorField = null;
            let heightErrorMessage = '';

            if (unitSystem === 'imperial') {
                const feet = getValue('height-feet');
                const inches = getValue('height-inches');
                heightValid = feet >= 3 && feet <= 8 && inches >= 0 && inches <= 11;
                heightErrorField = 'height-feet';
                heightErrorMessage = 'Please enter valid height (3-8 feet, 0-11 inches)';
            } else {
                const height = getValue('height');
                heightValid = height >= 100 && height <= 250;
                heightErrorField = 'height';
                heightErrorMessage = 'Please enter a valid height (100-250 cm)';
            }

            if (!heightValid) {
                showError(currentPanel, heightErrorField, heightErrorMessage);
                isValid = false;
            }

            // Waist & Hip Validation (Body Measurements)
            let waist, hip;

            // Get values based on current unit system
            if (unitSystem === 'metric') {
                waist = getValue('waist-cm');
                hip = getValue('hip-cm');

                // Validate CM values
                if (!waist || waist < 50 || waist > 200) {
                    showError(currentPanel, 'waist-cm', 'Please enter a valid waist measurement (50-200 cm)');
                    isValid = false;
                }
                if (!hip || hip < 60 || hip > 250) {
                    showError(currentPanel, 'hip-cm', 'Please enter a valid hip measurement (60-250 cm)');
                    isValid = false;
                }
            } else {
                // imperial (inches)
                waist = getValue('waist-inches');
                hip = getValue('hip-inches');

                // Validate inch values
                if (!waist || waist < 20 || waist > 80) {
                    showError(currentPanel, 'waist-inches', 'Please enter a valid waist measurement (20-80 inches)');
                    isValid = false;
                }
                if (!hip || hip < 24 || hip > 100) {
                    showError(currentPanel, 'hip-inches', 'Please enter a valid hip measurement (24-100 inches)');
                    isValid = false;
                }
            }

            if (isValid) {
                calculateComprehensiveHealthRisk();
            }
            break;


        case 3: // Body Fat
            const bodyFat = getValue('custom-body-fat');
            if (!bodyFat || bodyFat < 2 || bodyFat > 50) {
                showError(currentPanel, 'custom-body-fat', 'Please enter a valid body fat percentage (2-50%)');
                isValid = false;
            }
            break;

        case 4: // Activity Level
         
            if (!getRadioValue('activity-level')) {
                showError(currentPanel, 'activity-level', 'Please select your activity level', true);
                isValid = false;
            }
            break;
        case 5: // Exercise Activity
            if (!getRadioValue('structured-exercise')) {
                showError(currentPanel, 'structured-exercise', 'Please select whether you do structured exercise', true);
                isValid = false;
            }
            break;

        case 8: // Fitness Goals
            const selectedGoals = getSelectedGoals();
            if (selectedGoals.length === 0) {
                showError(currentPanel, 'fitness-goals', 'Please select 1 fitness goals', true);
                isValid = false;
            }
            break;
    }

    return isValid;
}

function showError(panel, field, message, isRadio = false) {
    let input;

    if (isRadio) {
        // For radio groups, target by name
        input = panel.querySelector(`input[name="${field}"]`) || document.querySelector(`input[name="${field}"]`);
    } else {
        // For normal inputs: use ID
        input = panel.querySelector(`#${field}`) || document.getElementById(field);
    }

    if (!input) {
        console.warn('Field not found:', field);
        return;
    }

    let errorElement;

    if (isRadio) {
        // Find form-group wrapper around the whole radio field
        const formGroup = input.closest('.radio-grid');
        if (!formGroup) {
            console.warn('Form group not found for radio:', field);
            return;
        }

        // Always look for error message inside form-group
        errorElement = formGroup.querySelector('.error-message');

        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'error-message';
            formGroup.appendChild(errorElement); 
        }

        errorElement.textContent = message;
        errorElement.style.display = 'block';
        formGroup.classList.add('error');
    } else {
        // Standard input
        const formGroup = input.closest('.form-group');
        if (!formGroup) {
            console.warn('Form group not found for:', field);
            return;
        }

        errorElement = formGroup.querySelector('.error-message');
        if (!errorElement) {
            errorElement = document.createElement('div');
            errorElement.className = 'error-message';
            formGroup.appendChild(errorElement); 
        }

        errorElement.textContent = message;
        errorElement.style.display = 'block';
        formGroup.classList.add('error');
    }
}

// Navigation functions
function getNextStep() {
    if (skipExercise && currentStep === 5) {
        return 7;
    }
    return currentStep + 1;
}

function showStep(step) {
    // Hide all panels
    document.querySelectorAll('.step-panel').forEach((panel) => {
        panel.classList.remove('active');
    });

    // Show current panel
    const currentPanel = document.querySelector(`.step-panel[data-step="${step}"]`);
    if (currentPanel) {
        currentPanel.classList.add('active');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }


    // Update navigation buttons
    const prevBtn = document.getElementById('prev-btn');
    const nextBtn = document.getElementById('next-btn');

    prevBtn.disabled = step === 1;

    const actualTotalSteps = skipExercise ? 10 : 10;
    nextBtn.textContent = step >= actualTotalSteps ? 'Complete' : 'Next';

    let resetBtn = document.getElementById('reset-btn');

    if (step > 1) {
        resetBtn.style.display = 'block';
    } else {
        resetBtn.style.display = 'none';
    }

    // Update progress bar
    updateProgress();

    // Update summary if on summary step
    if (step === 10) {
        updateSummary();
    }

    // Trigger calculations
    setTimeout(recalculateAll, 100);
}

// ENHANCED: nextStep with data collection on completion
function nextStep() {
    if (!validateStep(currentStep)) {
        return;
    }
    if(currentStep == 3){
        const compositionElement = document.querySelector('.composition-analysis');
            if (compositionElement) {
                compositionElement.classList.remove('hide');
                setTimeout(() => {
                    recalculateAll();
                    console.log('ok');
                }, 2000);
            }
    }
    if(currentStep == 4){
        const compositionElement = document.querySelector('.composition-analysis');
            compositionElement.removeAttribute('open');
        const exerciseElement = document.querySelector('.exercise-activity');
            if (exerciseElement) {
                exerciseElement.classList.remove('hide');

            }
        const selectedInput = document.querySelector('.radio-option.activity.selected input');
            if (selectedInput) {
                const textElement = document.querySelector('.exercise-text');
                if (textElement) {
                // Convert value to readable text
                const activityLabels = {
                    'sedentary': 'Sedentary',
                    'lightly_active': 'Lightly Active',
                    'moderately_active': 'Moderately Active',
                    'very_active': 'Very Active',
                    'extremely_active':'Extremely Active'
                };
        
                textElement.textContent = activityLabels[selectedInput.value] || selectedInput.value;
            } 
        
    }
}

    // Check if we're at the exercise check step
    if (currentStep === 5){
    
        skipExercise = document.getElementById('dont-exercise').checked;
     
        if (skipExercise) {
            document.querySelector(".exercise_wrapper.exercise_wrap").classList.add("hide");

            // Clear all exercise inputs
            Object.keys(EXERCISE_MET).forEach((intensity) => {
                const minutesId = intensity.replace('_', '-') + '-minutes';
                const input = document.getElementById(minutesId);
                if (input) input.value = '';
            });
        }
        else{
            const exerciseElement = document.querySelector('.exercise_wrapper.exercise_wrap');
            if (exerciseElement) {
                exerciseElement.classList.remove('hide');

            }
        }
    }
    if (currentStep === 6) {

        const exerciseIds = [
            "light-minutes",
            "moderate-minutes",
            "high-minutes",
            "very-high-minutes",
            "max-effort-minutes"
        ];

        const hasValue = exerciseIds.some(id => {
            const el = document.getElementById(id);
            return el && Number(el.value) > 0;
        });
    
        if (!hasValue) {
            openExercisePopup();
            return false;   
        }

    }


     if(currentStep === 7){
        const informationElement = document.querySelector('.daily-energy-tdee');
            if (informationElement) {
                informationElement.classList.remove('hide');
                 const compositionElement = document.querySelector('.exercise-activity');
                compositionElement.removeAttribute('open');
            }
    }
    if(currentStep == 8){
        const compositionElement = document.querySelector('.accordion');
            if (compositionElement) {
                compositionElement.classList.add('hide');
                 const completeElement = document.querySelector('.calc-outer-wrapper');
            if (completeElement) {
                completeElement.classList.add('complete-wrapper');
            }
            }
    }
    const nextStepNum = getNextStep();
    const actualTotalSteps = skipExercise ? 10 : 10;

    if (currentStep < actualTotalSteps) {
        currentStep = nextStepNum;
        showStep(currentStep);
    } else {
        // NEW: Collect final complete data when completing calculator
        const completeUserData = collectAllUserData();
        //console.log('Calculator completed! Complete user data:', completeUserData);

        // NEW: Make data globally accessible
        window.userCalculatorData = completeUserData;
        handleCalculatorCompletion(completeUserData);
        // Existing functionality remains unchanged
        //alert('Calculations completed!');
    }
}

function previousStep() {
    if (currentStep > 1) {
        // console.log(currentStep,"previos");
        if(currentStep !== 10){
              const compositionAccordion = document.querySelector('.accordion');
            if (compositionAccordion) {
                compositionAccordion.classList.remove('hide');
            }
            const calcAccordion = document.querySelector('.calc-outer-wrapper');
            if (calcAccordion) {
                calcAccordion.classList.remove('complete-wrapper');
            }
            
           
        }
        if (skipExercise && currentStep === 9) {
            currentStep = 8; 
        } else {
                currentStep--;
        }
        showStep(currentStep);
    }
}
function clearExercise(intensity) {
    const minutesId = intensity.replace('_', '-') + '-minutes';
    const caloriesId = intensity.replace('_', '-') + '-calories';

    const input = document.getElementById(minutesId);
    const calories = document.getElementById(caloriesId);

    if (input) input.value = '';
    if (calories) calories.textContent = '0';

    recalculateAll();
}

// Action functions
function printResults() {
    window.print();
}

// ENHANCED: downloadResults using the complete data collection
function downloadResults() {
    // NEW: Use the complete data collection function instead of manual creation
    const resultData = collectAllUserData();

    const dataStr = JSON.stringify(resultData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${resultData.personalInfo.name || 'user'}_fitness_plan.json`;
    link.click();
    URL.revokeObjectURL(url);
}

// Event listeners
document.addEventListener('DOMContentLoaded', function () {
    // Input listeners with real-time validation
    [
        'user-name',
        'user-email',
        'age',
        'weight',
        'height',
        'height-feet',
        'height-inches',
        'height-inches-only',
        'custom-body-fat',
    ].forEach((id) => {
        const input = document.getElementById(id);
        if (input) {
            input.addEventListener('input', function () {
                validateInput(this);
                recalculateAll();
            });
            input.addEventListener('blur', function () {
                validateInput(this);
            });
        }
    });
    ['waist-circumference', 'hip-circumference', 'waist-inches', 'waist-cm', 'hip-cm', 'hip-inches'].forEach((id) => {
        const input = document.getElementById(id);
        if (input) {
            input.addEventListener('input', function () {
                validateInput(this);
                calculateComprehensiveHealthRisk();
            });
        }
    });



    // Height unit change listeners
    document.querySelectorAll('input[name="height-unit"]').forEach((radio) => {
        radio.addEventListener('change', switchHeightUnits);
    });

    // Radio button listeners
    document.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', function () {
            // Update radio option styling
            const name = this.name;
            document.querySelectorAll(`input[name="${name}"]`).forEach((r) => {
                r.closest('.radio-option').classList.remove('selected');
            });
            this.closest('.radio-option').classList.add('selected');

            recalculateAll();
        });
    });

    // Checkbox listeners for goals
    document.querySelectorAll('input[name="fitness-goals"]').forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
            // Limit to 2 goals
            
            const checkedBoxes = document.querySelectorAll('input[name="fitness-goals"]:checked');
            if (checkedBoxes.length > 2) {
                this.checked = false;
                alert('You can select a maximum of 2 goals.');
                return;
            }

            // Update styling
            this.closest('.radio-option').classList.toggle('selected', this.checked);
            let goaltext =  this.closest('.radio-option').querySelector('.radio-text label').textContent;
              document.querySelector('.updategoal').textContent = goaltext;
            recalculateAll();
        });
    });

    // Exercise input listeners
    Object.keys(EXERCISE_MET).forEach((intensity) => {
        const minutesId = intensity.replace('_', '-') + '-minutes';
        const input = document.getElementById(minutesId);
        if (input) {
            input.addEventListener('input', recalculateAll);
        }
    });

    // Exercise checkbox listener
    const dontExerciseCheckbox = document.getElementById('dont-exercise');
    if (dontExerciseCheckbox) {
        dontExerciseCheckbox.addEventListener('change', function () {
            skipExercise = this.checked;
            recalculateAll();
        });
    }

    // Initialize
    showStep(1);
});

document.addEventListener('click', function (e) {
    // If we clicked directly on an input, let it handle itself naturally
    if (e.target.type === 'radio' || e.target.type === 'checkbox') {
        return;
    }

    const option = e.target.closest('.radio-option');
    if (option) {
        const input = option.querySelector('input[type="radio"], input[type="checkbox"]');
        if (input) {
            input.click();
        }
    }
});
function formatActivityLevel(activityLevel) {
    return activityLevel
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

function formatGoals(goalValues) {
    const goalMappings = {
        lose_fat_maintain_muscle: 'Lose Fat & Maintain Muscle',
        lose_fat_gain_muscle: 'Body Recomposition (Lose Fat & Gain Muscle)',
        maintain: 'Maintain Current Weight & Composition',
        gain_muscle: 'Gain Muscle Mass',
        get_faster: 'Improve Endurance Performance',
        increase_strength: 'Increase Strength & Power',
        recovering_injury: 'Recovery from Injury',
    };

    return goalValues.map((value) => goalMappings[value] || value).join(', ');
}

// Function to format exercise data
function formatExerciseData(exerciseData) {
    const entries = [];
    for (const [key, value] of Object.entries(exerciseData)) {
        if (value > 0) {
            entries.push(`${key}: ${value}min/week`);
        }
    }
    return entries.join(', ');
}

// Function to populate the form
function populateForm(completeUserData) {

    updateDashboard(completeUserData);
    try {
        // Find the app-embed element
        const appEmbedElement = document.getElementById('app-embed');
        if (!appEmbedElement) {
            console.warn('⚠ app-embed element not found');
            return;
        }

        // Access the shadow root
        const shadowRoot = appEmbedElement.shadowRoot;
        if (!shadowRoot) {
            console.warn('⚠ Shadow root not found or not open');
            return;
        }

      

        // Basic fields mapping - updated for new data structure
        const fieldMappings = {
            first_name: completeUserData.personalInfo?.name || '',
            email: completeUserData.personalInfo?.email || '',
            'custom#gender': completeUserData.personalInfo?.gender || '',
            'custom#age': completeUserData.personalInfo?.age || '',
            'custom#weight': completeUserData.measurements?.weight || '',
            'custom#height': completeUserData.measurements?.heightDisplay || '',
            'custom#bmi': completeUserData.measurements?.bmi ? completeUserData.measurements.bmi.toFixed(2) : '',
            'custom#body_fat': completeUserData.measurements?.bodyFat || '',
            'custom#lmb': completeUserData.measurements?.lbm ? completeUserData.measurements.lbm.toFixed(2) : '',
            'custom#fat_mass': completeUserData.measurements?.fatMass
                ? completeUserData.measurements.fatMass.toFixed(2)
                : '',
            'custom#activity_level': completeUserData.activity?.level
                ? formatActivityLevel(completeUserData.activity.level)
                : '',
            'custom#exercise_data': completeUserData.activity?.exerciseMinutes
                ? formatExerciseData(completeUserData.activity.exerciseMinutes)
                : 'No Exercise',
            'custom#rmr': completeUserData.metabolism?.rmr || '',
            'custom#neat': completeUserData.metabolism?.neat ? completeUserData.metabolism.neat.toFixed(2) : '',
            'custom#eat': completeUserData.metabolism?.eat || '0',
            'custom#tef': completeUserData.metabolism?.tef ? completeUserData.metabolism.tef.toFixed(2) : '',
            'custom#tdee': completeUserData.metabolism?.tdee ? completeUserData.metabolism.tdee.toFixed(2) : '',
            'custom#target_calories': completeUserData.nutrition?.targetCalories
                ? completeUserData.nutrition.targetCalories.toFixed(2)
                : '',
            'custom#protein': completeUserData.nutrition?.protein ? completeUserData.nutrition.protein.toFixed(2) : '',
            'custom#carbs': completeUserData.nutrition?.carbs ? completeUserData.nutrition.carbs.toFixed(2) : '',
            'custom#fats': completeUserData.nutrition?.fats || '',
            'custom#average_sleep_duration' : completeUserData.activity?.sleepHours || '',
            'custom#alcohol_consumption'  : completeUserData.activity?.smokingTier || '',
            'custom#smoking_habits' :  completeUserData.activity?.alcoholTier || '',
        };

        // Populate input fields using shadow root
        for (const [fieldId, value] of Object.entries(fieldMappings)) {
            const field = shadowRoot.getElementById(fieldId);
            if (field) {
                field.value = value;
                // Trigger input event to ensure any listeners are notified
                field.dispatchEvent(new Event('input', { bubbles: true }));
                field.dispatchEvent(new Event('change', { bubbles: true }));
             
            } else {
                console.warn(`⚠ Field not found in shadow DOM: ${fieldId}`);
            }
        }

        // Handle selected goals textarea using shadow root
        const selectedGoalsField = shadowRoot.querySelector('textarea[name="custom#selected_goals"]');
        if (selectedGoalsField) {
            const goalsText = completeUserData.goals ? formatGoals(completeUserData.goals) : '';
            selectedGoalsField.value = goalsText;
            // Trigger events for textarea as well
            selectedGoalsField.dispatchEvent(new Event('input', { bubbles: true }));
            selectedGoalsField.dispatchEvent(new Event('change', { bubbles: true }));

        } else {
            console.warn('⚠ Selected goals textarea not found in shadow DOM');
        }

   
        let btn = shadowRoot.querySelector('button[type="submit"][aria-disabled="false"]');

        if (btn) {
            convertFormDataToPDF(completeUserData, shadowRoot);
            //btn.click();
        }
    } catch (error) {
        console.error('❌ Error populating form:', error);
    }
} 

// Function to populate form from global userCalculatorData
function populateFormFromCalculator() {
    if (window.userCalculatorData) {
        console.log('🚀 Using calculator data to populate form...');
        completeUserData = window.userCalculatorData;
        populateForm();
    } else {
        console.log('🚀 Using default data to populate form...');
        populateForm();
    }
}
function handleCalculatorCompletion(completeUserData) {
    // console.log('Calculator completed! Complete user data:', completeUserData);

    // Make data globally accessible
    window.userCalculatorData = completeUserData;

    // Automatically populate the form if it exists on the same page
    if (document.getElementById('app-embed')) {
        console.log('📝 app-embed found on page, populating automatically...');
        // Add a small delay to ensure shadow DOM is fully rendered

        populateForm(completeUserData);
    }

    // localStorage.setItem('calculatorData', JSON.stringify(completeUserData));
}

document.addEventListener('DOMContentLoaded', function () {
    let unitInches = document.querySelector('#unit-inches');
    if (unitInches) {
        let changeEvent = new Event('click', { bubbles: true });
        unitInches.dispatchEvent(changeEvent);
    }
});

function updateDashboard(completuserdata) {
    // Hide step content and navigation buttons
    document.querySelectorAll('.step-content').forEach((el) => {
        el.style.display = 'none';
    });
    document.querySelectorAll('.navigation-buttons').forEach((el) => {
        el.style.display = 'none';
    });
      document.querySelectorAll('.calculator-container').forEach((el) => {
        el.style.display = 'none';
    });
    // Show container
    document.querySelectorAll('.container').forEach((el) => {
        el.style.display = 'block';
    });

    // Scroll to top with multiple fallbacks
    const scrollTargets = [document.querySelector('.container'), document.documentElement, document.body, window];

    scrollTargets.forEach((target) => {
        try {
            if (target === window) {
                window.scrollTo({ top: 0 });
            } else if (target && target.scrollTo) {
                target.scrollTo({ top: 0 });
            } else if (target) {
                target.scrollTop = 0;
            }
        } catch (error) {
            console.log('Scroll attempt failed for:', target, error);
        }
    });

    // Update personal info
    document.querySelector('.metric-card.purple .metric-value').textContent = completuserdata.personalInfo.name;
     document.querySelector('.person-name').textContent = `Hi ,${completuserdata.personalInfo.name}`;
     document.querySelector('.bmi-value').textContent = Math.ceil(completuserdata.personalInfo.bmi);
     document.querySelector('.bmr-value').textContent = completuserdata.metabolism.bmr;
    document.querySelector(
        '.metric-card.green .metric-value'
    ).innerHTML = `${completuserdata.personalInfo.age}<span class="metric-unit">year</span>`;
console.log(completuserdata)
    // Update measurements - FIXED: Use numeric values, ensure they exist
    const weight = completuserdata.measurements.weight;
    const height = completuserdata.measurements.height;
    const waist = completuserdata.measurements.waist;
    const hip = completuserdata.measurements.hip;
    const bodyFat = completuserdata.measurements.bodyFat;

    document.querySelector('.metric-card.orange .metric-value').innerHTML = `${weight ? weight.toFixed(2) : '0.00'
        }<span class="metric-unit">kg</span>`;

    document.querySelector('.metric-card.pink .metric-value').innerHTML = `${height ? height.toFixed(2) : '0.00'
        }<span class="metric-unit">cm</span>`;

    // Update body fat, waist, and hip
    const bodyFatCards = document.querySelectorAll('.metric-card.pink');

    // Waist
    if (bodyFatCards[1]) {
        bodyFatCards[1].querySelector('.metric-value').innerHTML = `${waist ? waist.toFixed(2) : '0.00'
            }<span class="metric-unit">cm</span>`;
    }

    // Hip
    if (bodyFatCards[2]) {
        bodyFatCards[2].querySelector('.metric-value').innerHTML = `${hip ? hip.toFixed(2) : '0.00'
            }<span class="metric-unit">cm</span>`;
    }

    // Body Fat
    if (bodyFatCards[3]) {
        bodyFatCards[3].querySelector('.metric-value').innerHTML = `${bodyFat ? bodyFat.toFixed(2) : '0.00'
            }<span class="metric-unit">%</span>`;
    }

 // Initialize charts
// Initialize charts
let tdeeChart = null;
let macroChart = null;

function createTDEEChart(completuserdata) {
  const ctx = document.getElementById('tdeeChart');
  if (!ctx) return;

  // Destroy existing chart if it exists
  if (tdeeChart) {
    tdeeChart.destroy();
  }

  const totalCalories = completuserdata.metabolism.rmr + 
                       completuserdata.metabolism.neat + 
                       completuserdata.metabolism.tef + 
                       completuserdata.metabolism.eat;

  // Update center text
  document.getElementById('currentCalories').textContent = Math.round(totalCalories);

  tdeeChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['RMR', 'NEAT', 'EAT', 'TEF'],
      datasets: [{
        data: [
          completuserdata.metabolism.rmr,
          completuserdata.metabolism.neat,
          completuserdata.metabolism.eat,
          completuserdata.metabolism.tef
        ],
        backgroundColor: [
          '#C45911', // RMR - Orange/Brown
          '#E67E22', // NEAT - Orange
          '#F39C12', // EAT - Light Orange
          '#F8B739'  // TEF - Yellow Orange
        ],
        borderWidth: 2,
        borderColor: '#fff',
        circumference: 180,
        rotation: 270
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      cutout: '65%',
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              return context.label + ': ' + context.parsed.toFixed(2) + ' cal';
            }
          }
        }
      }
    },
    plugins: [{
      id: 'textOnArc',
      afterDatasetDraw: function(chart) {
        const ctx = chart.ctx;
        const dataset = chart.data.datasets[0];
        const meta = chart.getDatasetMeta(0);
        
        ctx.save();
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'center';
        
        meta.data.forEach((arc, index) => {
          const value = dataset.data[index];
          const angle = (arc.startAngle + arc.endAngle) / 2;
          const radius = (arc.innerRadius + arc.outerRadius) / 2;
          
          const x = arc.x + Math.cos(angle) * radius;
          const y = arc.y + Math.sin(angle) * radius;
          
          // Draw value (larger, bold)
          ctx.font = 'bold 16px Arial';
          ctx.textBaseline = 'bottom';
          ctx.fillText(Math.round(value), x, y - 2);
          
          // Draw "cal/day" (smaller)
          ctx.font = '12px Arial';
          ctx.textBaseline = 'top';
          ctx.fillText('cal/day', x, y + 2);
        });
        
        ctx.restore();
      }
    }]
  });
}

function createMacroChart(completuserdata) {
  const ctx = document.getElementById('macroChart');
  if (!ctx) return;

  // Destroy existing chart if it exists
  if (macroChart) {
    macroChart.destroy();
  }

  // Update center text
  document.getElementById('targetCalories').textContent = Math.round(completuserdata.nutrition.targetCalories);
document.getElementById('proteinValue').textContent = Math.ceil(completuserdata.nutrition.protein) +' g/day';
document.getElementById('carbsValue').textContent = Math.ceil(completuserdata.nutrition.carbs) +' g/day';
document.getElementById('fatsValue').textContent = Math.ceil(completuserdata.nutrition.fats) +' g/day';
  // Update legend labels with values
  const legendItems = [
    { id: 'proteinLabel', value: completuserdata.nutrition.protein, color: '#4CAF50' },
    { id: 'carbsLabel', value: completuserdata.nutrition.carbs, color: '#81C784' },
    { id: 'fatsLabel', value: completuserdata.nutrition.fats, color: '#A5D6A7' }
  ];

  legendItems.forEach(item => {
    const element = document.getElementById(item.id);
    if (element) {
      element.textContent = `${item.value.toFixed(1)}g/day`;
    }
  });

  macroChart = new Chart(ctx, {
    type: 'doughnut',
    data: {
      labels: ['Protein', 'Carbs', 'Fats'],
      datasets: [{
        data: [
          completuserdata.nutrition.protein,
          completuserdata.nutrition.carbs,
          completuserdata.nutrition.fats
        ],
        backgroundColor: [
          '#4CAF50', // Protein - Green
          '#81C784', // Carbs - Light Green
          '#A5D6A7'  // Fats - Very Light Green
        ],
        borderWidth: 2,
        borderColor: '#fff',
        circumference: 180,
        rotation: 270
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2,
      cutout: '65%',
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function(context) {
              const label = context.label;
              return label + ': ' + context.parsed.toFixed(2) + 'g';
            }
          }
        }
      }
    },
    plugins: [{
      id: 'textOnArc',
      afterDatasetDraw: function(chart) {
        const ctx = chart.ctx;
        const dataset = chart.data.datasets[0];
        const meta = chart.getDatasetMeta(0);
        
        ctx.save();
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'center';
        
        meta.data.forEach((arc, index) => {
          const value = dataset.data[index];
          const angle = (arc.startAngle + arc.endAngle) / 2;
          const radius = (arc.innerRadius + arc.outerRadius) / 2;
          
          const x = arc.x + Math.cos(angle) * radius;
          const y = arc.y + Math.sin(angle) * radius;
          
          // Draw value (larger, bold)
          ctx.font = 'bold 16px Arial';
          ctx.textBaseline = 'bottom';
          ctx.fillText(value.toFixed(1), x, y - 2);
          
          // Draw "g/day" (smaller)
          ctx.font = '12px Arial';
          ctx.textBaseline = 'top';
          ctx.fillText('g/day', x, y + 2);
        });
        
        ctx.restore();
      }
    }]
  });

}

// Call these functions when you update the data
function updateCharts(completuserdata) {
  createTDEEChart(completuserdata);
  createMacroChart(completuserdata);
}

// Replace your existing update code with:
updateCharts(completuserdata);
    // Update recommendations section
    const recommendationsList = document.getElementById('recommendations-list');
    const recommendationsListUpdate = document.getElementById('recommendations-list-update');

    if (recommendationsList && recommendationsListUpdate) {
        recommendationsListUpdate.innerHTML = recommendationsList.innerHTML;
    }

    // PDF generation with proper wait for DOM updates
    setTimeout(() => {
        const element = document.querySelector('.container');

        if (!element) {
            console.error('Container element not found for PDF generation');
            return;
        }

        const rect = element.getBoundingClientRect();
        const elementHeight = element.scrollHeight;
        const elementWidth = element.scrollWidth;

        const widthInches = elementWidth / 96 + 1;
        const heightInches = elementHeight / 96 + 1;

        const opt = {
            margin: 0.2,
            filename: 'AUTHAYN_Health_Report.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff',
            },
            jsPDF: {
                unit: 'in',
                format: [widthInches, heightInches],
                orientation: 'portrait',
            },
            allowTaint: true,
        };

        html2pdf()
            .set(opt)
            .from(element)
            .save()
            .then(() => {
                console.log('PDF generated successfully');
                setTimeout(() => {
                    const embed = document.querySelector('shopify-forms-embed');
                    if (embed && embed.shadowRoot) {
                        const btn = embed.shadowRoot.querySelector('._formSubmitButton_cit2d_96');
                        if (btn) {
                            btn.click();
                            console.log('Done!');
                        }
                    }
                }, 1000);
            })
            .catch((err) => {
                console.error('PDF generation failed:', err);
            });
    }, 2000);
}
document.addEventListener('DOMContentLoaded', function () {
  const unitRadios = document.querySelectorAll('input[name="measurement-unit"]');

  unitRadios.forEach((radio) => {
    radio.addEventListener('change', function () {
      if (this.checked) {
        const selectedUnit = this.value;

        if (selectedUnit === 'cm') {
          document.getElementById('waist-cm-group').style.display = 'block';
          document.getElementById('waist-inches-group').style.display = 'none';
          document.getElementById('hip-cm-group').style.display = 'block';
          document.getElementById('hip-inches-group').style.display = 'none';

          // Clear inch fields - Fixed selectors
          document.getElementById('waist-inches').value = '';
          document.getElementById('hip-inches').value = '';
        } else {
          document.getElementById('waist-cm-group').style.display = 'none';
          document.getElementById('waist-inches-group').style.display = 'block';
          document.getElementById('hip-cm-group').style.display = 'none';
          document.getElementById('hip-inches-group').style.display = 'block';

          // Clear cm fields - Fixed selectors
          document.getElementById('waist-cm').value = '';
          document.getElementById('hip-cm').value = '';
        }
      }
    });
  });
});


//2-12-25

// Helper to remove hide class
function showField(selector) {
    const el = document.querySelector(selector);
    if (el) el.classList.remove("hide");
}

// Detect selected unit system
function getUnitSystem() {
    return document.querySelector('input[name="unit-system"]:checked').value;
}

/* ------------------------
   FULL NAME
-------------------------*/
const nameInput = document.getElementById("user-name");
const nameDisplay = document.querySelector(".profile-name-value");

// Handle input changes
nameInput.addEventListener("input", function() {
    const value = this.value.trim();
    nameDisplay.textContent = value;
    
    if (value) {
        showField(".profile-name");
    } else {
        hideField(".profile-name");
    }
});

// Initialize on page load
if (nameInput.value.trim()) {
    nameDisplay.textContent = nameInput.value.trim();
    showField(".profile-name");
}

/* ------------------------ 
   EMAIL 
-------------------------*/
const emailInput = document.getElementById("user-email");
const emailDisplay = document.querySelector(".profile-email-value");

// Handle input changes
emailInput.addEventListener("input", function() {
    const value = this.value.trim();
    emailDisplay.textContent = value;
    
    if (value) {
        showField(".pro-email");
    } else {
        hideField(".pro-email");
    }
});

// Initialize on page load
if (emailInput.value.trim()) {
    emailDisplay.textContent = emailInput.value.trim();
    showField(".pro-email");
}

// Helper function to hide fields (add this if you don't have it)
function hideField(selector) {
    const field = document.querySelector(selector);
    if (field) {
        field.style.display = 'none';
    }
}
/* ------------------------
   GENDER
-------------------------*/
document.querySelectorAll('input[name="biological-gender"]').forEach(el => {
    el.addEventListener("change", function () {
        document.querySelector(".profile-gender-value").textContent = this.value;
        showField(".pro-gender");
    });
});

/* ------------------------
   AGE
-------------------------*/
document.getElementById("age").addEventListener("input", function () {
    document.querySelector(".profile-age-value").textContent = this.value;
    showField(".pro-age");
});

/* ------------------------
   WEIGHT
-------------------------*/
function updateWeight() {
    const sys = getUnitSystem();
    const imperialGroup = document.getElementById("weight-imperial-group");
    const metricGroup = document.getElementById("weight-metric-group");
    let valueText = "";

    if (sys === "imperial") {
        imperialGroup.style.display = "block";
        metricGroup.style.display = "none";

        const lbs = document.getElementById("weight-lbs").value;
        valueText = lbs !== "" ? lbs + " lbs" : "0 lbs"; // <-- default 0 lbs
    } else {
        imperialGroup.style.display = "none";
        metricGroup.style.display = "block";

        const kg = document.getElementById("weight").value;
        valueText = kg !== "" ? kg + " kg" : "0 kg"; // <-- default 0 kg
    }

    document.querySelector(".profile-weight-value").textContent = valueText;
     if (valueText !== "" && valueText !== "0 lbs" && valueText !== "0 kg") {
        showField(".pro-weight");
    }
}


/* ------------------------
   HEIGHT
-------------------------*/
function updateHeight() {
    const sys = getUnitSystem();
    const heightImperialGroup = document.getElementById("height-imperial-group");
    const heightMetricGroup = document.getElementById("height-metric-group");

    if (sys === "imperial") {
    heightImperialGroup.style.display = "block";
    heightMetricGroup.style.display = "none";

    const ft = document.getElementById("height-feet").value;
    const inch = document.getElementById("height-inches").value;
    const valueText = (ft || 0) + " ft " + (inch || 0) + " in";
    document.querySelector(".profile-height-value").textContent = valueText;
    
    // Show only if both ft and inch have actual values (not 0)
    if (ft && ft !== "0" || inch && inch !== "0") {
        showField(".pro-height");
    }
} else {
    heightImperialGroup.style.display = "none";
    heightMetricGroup.style.display = "block";

    const cm = document.getElementById("height").value;
    const valueText = cm ? cm + " cm" : "";
    document.querySelector(".profile-height-value").textContent = valueText;
    
    // Show only if cm has a value greater than 0
    if (cm && cm !== "0") {
        showField(".pro-height");
    }
}
    
}

/* ------------------------
   WAIST
-------------------------*/
function updateWaist() {
    const sys = getUnitSystem();
    const waistImperialGroup = document.getElementById("waist-inches-group");
    const waistMetricGroup = document.getElementById("waist-cm-group");

   if (sys === "imperial") {
    waistImperialGroup.style.display = "block";
    waistMetricGroup.style.display = "none";

    const v = document.getElementById("waist-inches").value;
    document.querySelector(".profile-waist-value").textContent = v ? v + " in" : "";
    
    // Show only if value exists and is not 0
    if (v && v !== "0") {
        showField(".pro-waist");
    }
} else {
    waistImperialGroup.style.display = "none";
    waistMetricGroup.style.display = "block";

    const v = document.getElementById("waist-cm").value;
    document.querySelector(".profile-waist-value").textContent = v ? v + " cm" : "";
    
    // Show only if value exists and is not 0
    if (v && v !== "0") {
        showField(".pro-waist");
    }
}
    
}

/* ------------------------
   HIP
-------------------------*/
function updateHip() {
    const sys = getUnitSystem();
    const hipImperialGroup = document.getElementById("hip-inches-group");
    const hipMetricGroup = document.getElementById("hip-cm-group");

    if (sys === "imperial") {
        hipImperialGroup.style.display = "block";
        hipMetricGroup.style.display = "none";

        const v = document.getElementById("hip-inches").value;
        document.querySelector(".profile-hip-value").textContent = v ? v + " in" : "";
        if (v !== "") {
            showField(".pro-hip");
        }
    } else {
        hipImperialGroup.style.display = "none";
        hipMetricGroup.style.display = "block";

        const v = document.getElementById("hip-cm").value;
        document.querySelector(".profile-hip-value").textContent = v ? v + " cm" : "";
        if (v !== "") {
            showField(".pro-hip");
        }
    }
   
    
}

/* ------------------------
   EVENT LISTENERS
-------------------------*/

// Weight
document.getElementById("weight-lbs").addEventListener("input", updateWeight);
document.getElementById("weight").addEventListener("input", updateWeight);

// Height
document.getElementById("height-feet").addEventListener("input", updateHeight);
document.getElementById("height-inches").addEventListener("input", updateHeight);
document.getElementById("height").addEventListener("input", updateHeight);

// Waist
document.getElementById("waist-inches").addEventListener("input", updateWaist);
document.getElementById("waist-cm").addEventListener("input", updateWaist);

// Hip
document.getElementById("hip-inches").addEventListener("input", updateHip);
document.getElementById("hip-cm").addEventListener("input", updateHip);

// Unit system change
document.querySelectorAll('input[name="unit-system"]').forEach(el => {
    el.addEventListener("change", () => {
        updateWeight();
        updateHeight();
        updateWaist();
        updateHip();
    });
});

// Initial update on page load
updateWeight();
updateHeight();
updateWaist();
updateHip();


//4-12-25


function updateExerciseSummary(type, minutes) {

  const summaryWrapper = document.querySelector(".exercise_wrap");

  // summary card selector
  const card = document.querySelector(`.${type}-wrap`);
  const minuteSpan = document.querySelector(`.${type}-mint`);
  const calorieSpan = document.getElementById(`${type}-cal`);

  // If blank or zero → hide card
  if (!minutes || minutes === 0) {
    card.classList.add("hide");

    // Check if all cards are hidden → hide main wrapper
    const anyVisible = [...document.querySelectorAll(".exercise_wrap .exercise-card")]
      .some(el => !el.classList.contains("hide"));
    if (!anyVisible) {
      summaryWrapper.classList.add("hide");
    }
    return;
  }

  // If has value → show main wrapper
  summaryWrapper.classList.remove("hide");

  // Show card
  card.classList.remove("hide");

  // Update minutes text
  minuteSpan.textContent = minutes;

  // Calculate calories/day
  setTimeout(() => {
    const topCaloriesEl = document.getElementById(`${type}-calories`);
    if (topCaloriesEl) {
        const topCalories = topCaloriesEl.textContent.trim();
        calorieSpan.textContent = topCalories;
    }
}, 1000);

}

// Attach events to inputs
function initExerciseInputs() {
  const fields = [
    { id: "light-minutes", type: "light" },
    { id: "moderate-minutes", type: "moderate" },
    { id: "high-minutes", type: "high" },
    { id: "very-high-minutes", type: "very-high" },
    { id: "max-effort-minutes", type: "max-effort" }
  ];

  fields.forEach(item => {
    const input = document.getElementById(item.id);
    input.addEventListener("input", function () {
      updateExerciseSummary(item.type, parseInt(this.value) || 0);
    });
  });
}

initExerciseInputs();

// Clear button
function clearExercise(type) {
  const ids = {
    light: "light-minutes",
    moderate: "moderate-minutes",
    high: "high-minutes",
    very_high: "very-high-minutes",
    max_effort: "max-effort-minutes"
  };

  const input = document.getElementById(ids[type]);
  input.value = "";
  updateExerciseSummary(type, 0);
}
// ----9-12-25 ----//
// pop up function

function openExercisePopup() {
    document.getElementById("exerciseErrorPopup").style.display = "flex";
}

function closeExercisePopup() {
    document.getElementById("exerciseErrorPopup").style.display = "none";
}


/* ---------------------------
   HELPER FUNCTION - Show Random LI
----------------------------*/
function showRandomLi(ul) {
  if (!ul) return;
  
  const allLis = ul.querySelectorAll("li");
  
  // Hide all LIs first
  allLis.forEach(li => li.style.display = "none");
  
  // Show one random LI
  if (allLis.length > 0) {
    const randomIndex = Math.floor(Math.random() * allLis.length);
    allLis[randomIndex].style.display = "block";
  }
}

/* ---------------------------
   SLEEP HOURS
----------------------------*/
document.querySelectorAll('input[name="sleep-hours"]').forEach(radio => {
  radio.addEventListener('change', () => {

    // Summary update
    const value = radio.value;
    let text = "";
    if (value === "under_5") text = "< 5 hours";
    if (value === "5_6") text = "5–6 hours";
    if (value === "6_7") text = "6–7 hours";
    if (value === "7_8") text = "7–8 hours";
    if (value === "8_plus") text = "8+ hours";
    document.getElementById("summary-lifestyle").textContent = text;

    // Show/Hide UL messages
    document.querySelectorAll(".slect_oprion-duration").forEach(ul => {
      ul.classList.add("hide");
    });

    const parentLabel = radio.closest("label");
    const ul = parentLabel.querySelector(".slect_oprion-duration");
    if (ul) {
      ul.classList.remove("hide");
      showRandomLi(ul); // Show only 1 random LI
    }

  });
});

/* ---------------------------
   ALCOHOL — YES/NO
----------------------------*/
document.querySelectorAll('input[name="alcohol-consumption"]').forEach(radio => {
  radio.addEventListener('change', () => {
    const value = radio.value;
    let text = value === "yes" ? "Yes" : "No – Well Done!";
    document.getElementById("summary-life-alcohol").textContent = text;

    const tier = document.querySelector('.alcohol-tier');
    if (value === "yes") {
      tier.style.display = "block";
    } else {
      tier.style.display = "none";
      document.getElementById("summary-life-alcohol").textContent = "No – Well Done!";

      // hide UL messages if NO
      document.querySelectorAll(".slect_oprion-alcohol").forEach(ul => {
        ul.classList.add("hide");
      });
    }
  });
});

/* ---------------------------
   ALCOHOL TIER
----------------------------*/
const alcoholTierRadios = document.querySelectorAll('input[name="alcohol-tier"]');
alcoholTierRadios.forEach(radio => {
  radio.addEventListener("change", () => {

    // Summary update
    let text = "";
    if (radio.value === "casual") text = "Casual (1–2 drinks/week)";
    if (radio.value === "regular") text = "Regular (3–7 drinks/week)";
    if (radio.value === "heavy") text = "Heavy (>7 drinks/week)";
    document.getElementById("summary-life-alcohol").textContent = text;

    // UL show/hide
    document.querySelectorAll(".slect_oprion-alcohol").forEach(ul => {
      ul.classList.add("hide");
    });

    const parentLabel = radio.closest("label");
    const ul = parentLabel.querySelector(".slect_oprion-alcohol");
    if (ul) {
      ul.classList.remove("hide");
      showRandomLi(ul); // Show only 1 random LI
    }

  });
});

/* ---------------------------
   SMOKING — YES/NO
----------------------------*/
document.querySelectorAll('input[name="smoking-habit"]').forEach(radio => {
  radio.addEventListener('change', () => {

    const value = radio.value;
    document.getElementById("summary-life-smok").textContent =
      value === "yes" ? "Yes" : "No – Well Done!";

    const tier = document.querySelector('.smoking-tier');
    if (value === "yes") {
      tier.style.display = "block";
    } else {
      tier.style.display = "none";
      document.getElementById("summary-life-smok").textContent = "No – Well Done!";

      // hide UL messages if NO
      document.querySelectorAll(".slect_oprion-smoking").forEach(ul => {
        ul.classList.add("hide");
      });
    }
  });
});

/* ---------------------------
   SMOKING TIER
----------------------------*/
const smokingTierRadios = document.querySelectorAll('input[name="smoking-tier"]');
smokingTierRadios.forEach(radio => {
  radio.addEventListener("change", () => {

    // Summary update
    let text = "";
    if (radio.value === "casual") text = "Casual (1–2/day)";
    if (radio.value === "regular") text = "Regular (5–10/day)";
    if (radio.value === "heavy") text = "Heavy (>10/day)";
    document.getElementById("summary-life-smok").textContent = text;

    // UL show/hide
    document.querySelectorAll(".slect_oprion-smoking").forEach(ul => {
      ul.classList.add("hide");
    });

    const parentLabel = radio.closest("label");
    const ul = parentLabel.querySelector(".slect_oprion-smoking");
    if (ul) {
      ul.classList.remove("hide");
      showRandomLi(ul); // Show only 1 random LI
    }

  });
});

// ----11-12-25 ----//

const check = document.getElementById("disclaimer-check");
const disclaimerBlock = document.getElementById("disclaimer-block");

const progressContainer = document.querySelector(".progress-container");
const stepContent = document.querySelector(".step-content");
const navButtons = document.querySelectorAll(".navigation-buttons");

check.addEventListener("change", function () {
  if (this.checked) {
    disclaimerBlock.style.display = "none";

    progressContainer.style.display = "block";   
    stepContent.style.display = "flex";          
     navButtons.forEach(btn => {
      btn.style.display = "flex";
    });           

  } else {
    disclaimerBlock.style.display = "flex";

    progressContainer.style.display = "none";
    stepContent.style.display = "none";
     navButtons.forEach(btn => {
      btn.style.display = "none";
    });
  }
});



